const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        "Seleziona la categoria principale dell'edificio, ad esempio ufficio, scuola o magazzino. Il campo viene utilizzato per scegliere i valori standard e i profili corretti nel calcolo.",
      yearOfConstruction:
        "Indica l'anno di costruzione dell'edificio, oppure l'anno dell'ultima ristrutturazione importante se più rappresentativo. Utilizzato tra l'altro per valutare il probabile standard tecnico.",
      numberOfFloors:
        "Indica il numero totale di piani fuori terra dell'edificio. Il campo viene utilizzato come base per la geometria, il volume e l'ulteriore suddivisione in zone.",
    },
    thermalZones: {
      zoneCategory:
        "Una zona termica è una parte dell'edificio trattata come un'unica unità nel calcolo, tipicamente con uso e clima interno simili. Assegna alla zona un nome chiaro e seleziona una categoria di zona. La categoria definisce i profili standard per il tempo di utilizzo, i carichi interni e le ipotesi tecniche.",
      buildingSubcategory:
        'Seleziona una sottocategoria se desideri una classificazione più precisa della zona. Lascia il campo vuoto se la categoria di zona abituale è sufficiente.',
      zoneClimate:
        'Indica se la zona è riscaldata, parzialmente riscaldata o non riscaldata. Lo stato climatico determina come la zona entra nel fabbisogno di riscaldamento e raffreddamento ed è una condizione fondamentale per il calcolo energetico.',
      bra: "La BRA è la superficie utile della zona, ovvero la superficie di pavimento all'interno delle pareti esterne considerata come superficie riscaldata. Indica la BRA in m². La superficie è uno degli input più importanti e influisce direttamente su quasi tutti i calcoli.",
      floors:
        'Indica su quanti piani si estende la zona se non è limitata a un solo livello. Se la zona si trova su un solo livello, il campo può spesso essere lasciato vuoto.',
      floorHeight:
        "Indica l'altezza media di piano in metri per la zona. Utilizzata insieme alla superficie per calcolare il volume e le portate d'aria.",
      indoorTemp:
        "La temperatura della zona all'avvio della simulazione. Non è un setpoint: i setpoint di riscaldamento e raffreddamento si impostano nel Programma di riscaldamento e nel Programma di raffreddamento.",
      tekStandard:
        "TEK indica la normativa edilizia norvegese, ad esempio TEK10 e TEK17, che stabilisce requisiti tra l'altro per valori U e tenuta all'aria. Seleziona lo standard TEK pertinente se desideri controllare i valori standard in modo più preciso di quanto consenta il solo anno di costruzione.",
      airLeakageN50:
        "Il valore di tenuta all'aria (n50) descrive quanto è ermetico l'edificio, misurato come ricambi d'aria all'ora a 50 Pa di differenza di pressione. Indica il valore se è noto da una prova di pressurizzazione o dalla documentazione. Se il campo è vuoto, vengono utilizzati valori standard rappresentativi.",
      thermalBridgeCoeff:
        'Un ponte termico è un punto della costruzione con maggiore dispersione di calore, tipicamente dove solai e pareti incontrano la struttura esterna. Seleziona la struttura portante o la categoria di ponte termico se desideri modellare i ponti termici in modo più preciso. Normalmente utilizzato solo quando si dispone di buone informazioni di fisica edilizia.',
      thermalBridgePsiValue:
        'Il valore normalizzato di ponte termico (ψ) esprime la dispersione di calore aggiuntiva totale dovuta ai ponti termici per m² di superficie di pavimento. Indica il valore se è noto da un calcolo. Normalmente può essere lasciato vuoto in un rilievo standard.',
      heatingEmissionSystem:
        "Il sistema di emissione del calore è il modo in cui il calore viene fornito all'ambiente, ad esempio radiatore, convettore o riscaldamento a pavimento. La scelta influisce sulla temperatura di mandata necessaria e sulla regolazione. Utile per il dettaglio, ma di solito non necessario nella prima registrazione.",
      coolingEmissionSystem:
        "Il sistema di emissione del freddo è il modo in cui il raffreddamento viene fornito all'ambiente, ad esempio trave fredda, ventilconvettore o soffitto radiante freddo. La scelta influisce sul livello di temperatura e sulla regolazione. Utile per il dettaglio, ma di solito non necessario nella prima registrazione.",
      zoneConnections:
        'Un collegamento di zona descrive una superficie in cui due zone, o una zona e una condizione climatica, scambiano calore, ad esempio una parete interna verso una zona più fredda. Usa questo quando tale scambio di calore è importante per il modello. Normalmente rilevante solo in una configurazione più dettagliata.',
      connectionArea:
        "Indica l'area in m² della superficie che collega le zone. Insieme al valore U determina quanta energia termica viene scambiata. Da compilare solo quando si modella effettivamente un collegamento di zona.",
      connectionUValue:
        'Indica il valore U della superficie collegata se disponibile. In caso contrario, il collegamento può solitamente essere semplificato o omesso.',
      heatingSchedule:
        "Un programma di riscaldamento descrive come il setpoint e il funzionamento variano nell'arco del giorno e della settimana, ad esempio l'abbassamento notturno. Usalo quando la zona ha un funzionamento variabile. Offre una simulazione più realistica rispetto ai profili standard fissi.",
      hasFloorToGround:
        "Attiva questa opzione se la zona ha un pavimento verso il terreno. La disattivazione nasconde l'elemento e rimuove la superficie salvata dal calcolo energetico.",
      hasRoof:
        "Attiva questa opzione se la zona ha un tetto verso l'esterno. La disattivazione nasconde l'elemento e rimuove la superficie salvata dal calcolo energetico.",
      isBasement:
        "Attiva questa opzione quando la zona è un seminterrato sotto il livello del terreno. La dispersione verso il terreno viene allora calcolata dall'elemento Costruzione del seminterrato, e tetto, pavimento su terreno, pareti esterne, finestre e porte di questa zona sono esclusi dal calcolo energetico.",
      basement: {
        area: 'Inserisci la superficie del pavimento del seminterrato contro terra in m². È necessaria per calcolare la dispersione verso il terreno e normalmente coincide con la BRA della zona seminterrata.',
        wallPerimeter:
          'Inserisci la lunghezza in metri di parete del seminterrato a contatto con il terreno. Insieme alla superficie fornisce la dimensione caratteristica del pavimento. Se il campo è vuoto si assume una pianta quadrata.',
        fillHeight:
          'Inserisci la profondità media dal terreno al pavimento del seminterrato in metri. Determina quanta parte della parete cede calore al terreno. 0 significa platea su terreno.',
        wallThickness:
          'Inserisci lo spessore totale della parete del seminterrato a livello del terreno in metri, isolamento compreso. Se il campo è vuoto si usano 0,3 m.',
        wallConstructionType:
          'Seleziona la costruzione della parete interrata del seminterrato, oppure un periodo TEK per usarne il requisito. La scelta suggerisce il valore U.',
        wallUValue:
          'Il valore U della costruzione della parete interrata (W/m²K). Inseriscilo se lo conosci dalla documentazione, altrimenti viene usato il valore suggerito.',
        floorConstructionType:
          'Seleziona la costruzione del pavimento del seminterrato contro terra, oppure un periodo TEK per usarne il requisito. La scelta suggerisce il valore U.',
        floorUValue:
          'Il valore U della costruzione del pavimento contro terra (W/m²K). Inseriscilo se lo conosci dalla documentazione, altrimenti viene usato il valore suggerito.',
      },
      floor: {
        type: 'Il tipo di pavimento verso il terreno descrive come è costituito il pavimento verso il terreno o verso uno spazio non riscaldato, ad esempio platea su terreno o pavimento sopra una cantina. Seleziona quello che descrive meglio la costruzione. La scelta serve a proporre valori standard pertinenti, tra cui il valore U.',
        area: 'Indica la superficie del pavimento verso il terreno in m² per la parte della zona da registrare. La superficie è necessaria per calcolare la dispersione di calore attraverso il pavimento.',
        uValue:
          "Il valore U indica quanta energia termica attraversa la costruzione per m² e grado di differenza di temperatura (W/m²K). Un valore più basso significa un isolamento migliore. Indicalo se lo conosci da documentazione o calcolo, altrimenti vengono utilizzati valori nominali basati sul tipo e sull'anno selezionati.",
      },
      structuralNodes: {
        boundary:
          "Un nodo strutturale è un punto in cui gli elementi dell'edificio si incontrano, ad esempio tra un solaio e una parete esterna, ed è tipicamente un ponte termico con dispersione di calore aggiuntiva. Usa i nodi strutturali quando vuoi registrare tali dettagli. Normalmente rilevante solo a un livello di dettaglio più elevato.",
        length:
          'Indica la lunghezza del nodo o del ponte termico in questione in metri. Da compilare solo se si utilizzano nodi strutturali.',
        height:
          "Indica l'altezza del nodo in questione in metri se pertinente. Utilizzata insieme alle altre misure per una descrizione geometrica dettagliata.",
        width:
          'Indica la larghezza del nodo in questione in metri se pertinente. Il campo viene utilizzato solo per la registrazione dettagliata dei nodi strutturali.',
      },
      roof: {
        angle:
          "L'angolo del tetto è l'inclinazione della superficie del tetto in gradi, dove 0 indica un tetto piano. Viene registrato per l'ispezione, ma il calcolo energetico non lo utilizza ancora: la dispersione attraverso il tetto è calcolata da superficie e valore U, e le finestre sul tetto non ricevono apporti solari nel calcolo.",
        type: 'La costruzione del tetto descrive come è costituito il tetto, ad esempio tetto compatto, tetto a falde ventilato o capriate. Seleziona quella che descrive meglio il tetto. La scelta costituisce la base per il valore U standard e le altre ipotesi.',
        area: 'Indica la superficie del tetto in m² inclusa nella zona. La superficie è necessaria per calcolare la trasmissione attraverso il tetto.',
        uValue:
          "Il valore U indica quanta energia termica attraversa la costruzione del tetto per m² e grado di differenza di temperatura (W/m²K). Un valore più basso significa un isolamento migliore. Indicalo se è noto, altrimenti viene utilizzato un valore nominale basato sulla costruzione e sull'età selezionate.",
        glassType:
          'Attiva questa opzione se il tetto ha finestre o lucernari, e seleziona il tipo di vetro. Il tipo di vetro, ad esempio doppio o triplo, determina sia la dispersione di calore sia la quantità di energia solare che entra attraverso la superficie del tetto.',
        windowArea:
          'Indica la superficie totale di finestre o lucernari in m². Il campo è rilevante solo se il tetto ha effettivamente finestre o lucernari.',
        windowUValue:
          'Il valore U delle finestre da tetto indica la dispersione di calore attraverso il vetro e il telaio stessi (W/m²K). Un valore più basso significa un isolamento migliore. Indicalo se è noto, altrimenti i valori standard sono spesso sufficienti.',
        gValue:
          'Il valore g (fattore solare) descrive la quota di energia solare che attraversa il vetro, da 0 a 1. Un valore g elevato fornisce più calore solare gratuito in inverno, ma anche un maggiore fabbisogno di raffreddamento in estate.',
        externalBlindsGt:
          'Le veneziane esterne sono montate sul lato esterno del vetro e riducono efficacemente la radiazione solare. Il fattore solare (gt) descrive quanta energia solare passa quando la schermatura è attiva. Registra questo quando tale schermatura solare ha un effetto evidente.',
        externalScreenGt:
          "Uno screen esterno è una schermatura tessile esterna che attenua la radiazione solare. Il fattore solare (gt) indica quanta energia solare passa con il telo abbassato. Da compilare solo se la soluzione è presente nell'edificio.",
        internalShadingGt:
          "La schermatura interna, ad esempio veneziane o tende all'interno, attenua il sole ma in modo meno efficace della schermatura esterna. Il fattore solare (gt) descrive l'apporto solare residuo. Utilizzato per migliorare il calcolo degli apporti solari.",
      },
      groundConditions: {
        type: "Le condizioni del terreno descrivono le masse sotto l'edificio, ad esempio argilla, sabbia o roccia, che influenzano la dispersione di calore verso il terreno. Usa questo quando disponi di informazioni specifiche sul terreno. È tipicamente un campo di dettaglio.",
        thermalConductivity:
          'La conducibilità termica (λ) indica quanto bene il terreno conduce il calore, in W/mK. Un valore più elevato comporta una maggiore dispersione di calore verso il terreno. Indica un valore documentato se ne disponi, altrimenti il campo può essere lasciato vuoto.',
        heatCapacity:
          'La capacità termica descrive quanto calore il terreno può immagazzinare e attenua le fluttuazioni della dispersione di calore nel tempo. Indicala se è nota. Normalmente può essere lasciata vuota in un rilievo energetico ordinario.',
        penetrationDepth:
          'La profondità di penetrazione periodica è la profondità nel terreno influenzata dalle variazioni stagionali di temperatura. Viene utilizzata in modelli del terreno più dettagliati. Il campo di solito non è necessario in una registrazione standard.',
      },
      internalLoads: {
        lighting:
          "L'illuminazione è un apporto di calore interno: l'energia utilizzata dalle sorgenti luminose si trasforma in gran parte in calore nella zona. Registra il livello di illuminazione ed eventuali profili di funzionamento. Questo influisce sia sul consumo di elettricità sia sul fabbisogno di raffreddamento.",
        equipment:
          "Le apparecchiature tecniche come computer, monitor e altre apparecchiature fisse cedono calore all'ambiente oltre a consumare elettricità, e costituiscono quindi un apporto di calore interno. Registra la potenza tipica e il profilo di funzionamento della zona.",
        occupancy:
          "Le persone cedono calore e umidità e influenzano allo stesso tempo il fabbisogno di ventilazione. Registra l'occupazione tramite numeri e profili o una configurazione standard che descrive l'uso normale della zona.",
        dishwasher:
          "Seleziona la lavastoviglie se è un carico rilevante nella zona. La quota di acqua calda indica quanta parte del consumo è coperta da acqua calda sanitaria anziché dal riscaldamento proprio dell'apparecchio. Normalmente utilizzato solo quando gli elettrodomestici sono significativi.",
        washingMachine:
          "Seleziona la lavatrice se è un carico rilevante nella zona. La quota di acqua calda indica quanta parte dell'acqua la macchina preleva dal sistema di acqua calda invece di riscaldarla da sé.",
        tumbleDryer:
          "Seleziona l'asciugatrice se è un carico rilevante nella zona. Un'eventuale quota di acqua calda descrive quanta parte del fabbisogno energetico è coperta tramite acqua calda sanitaria anziché elettricità diretta.",
      },
      thermalMass: {
        heatCapacityCategory:
          "La massa termica è la capacità dell'edificio di immagazzinare calore, il che attenua le oscillazioni di temperatura e sposta nel tempo il fabbisogno di riscaldamento e raffreddamento. Seleziona una categoria di capacità termica, ad esempio costruzione leggera o pesante, se desideri regolare questo oltre i valori standard.",
        normalizedHeatCapacity:
          'La capacità termica normalizzata esprime quanto calore la zona può immagazzinare per m² di superficie di pavimento (Wh/m²K). Indica un valore più preciso se ne disponi, altrimenti il campo può essere lasciato vuoto e viene utilizzata la categoria.',
        cladding:
          'Il rivestimento interno, ad esempio cartongesso, legno o calcestruzzo a vista, influisce su quanta parte della massa termica è effettivamente attiva verso il locale. Seleziona il tipo se desideri una descrizione più dettagliata.',
        heatCapacity:
          'Indica la capacità termica delle pareti interne se è nota. Questo descrive quanto calore le costruzioni interne possono immagazzinare e viene utilizzato solo per una modellazione più dettagliata della massa termica.',
        furnitureGrade:
          "Mobili e arredi contribuiscono anch'essi alla massa termica. Seleziona un grado di arredamento che descrive quanto la zona è arredata se questo è rilevante. Il campo è normalmente un campo di dettaglio.",
        massFactor:
          'Il fattore di massa regola quanto i mobili e gli arredi contribuiscono alla massa termica della zona. Indica un valore se desideri sovrascrivere il valore standard.',
      },
      exteriorWall: {
        direction:
          "L'orientamento determina quanto sole riceve la facciata e come il vento e il clima esterno influenzano la dispersione di calore. Seleziona la direzione, ad esempio nord, sud, est o ovest, per la parete registrata.",
        type: 'Il tipo di parete descrive come è costituita la parete esterna, ad esempio struttura in legno, muratura o calcestruzzo con isolamento. Seleziona quello che descrive meglio la parete. La scelta serve a proporre valori standard pertinenti.',
        area: 'Inserire la superficie lorda della parete esterna in m², comprese finestre, porte e portoni. Il calcolo sottrae da sé le aperture registrate sulla parete, quindi una superficie netta sottostimerebbe la dispersione attraverso la parete.',
        uValue:
          "Il valore U indica quanta energia termica attraversa la parete per m² e grado di differenza di temperatura (W/m²K). Un valore più basso significa un isolamento migliore. Indicalo se è noto, altrimenti vengono utilizzati valori nominali basati sul tipo di parete e sull'età.",
        windowShadingFactor:
          "La quota di luce solare diretta che la finestra perde per l'ombreggiamento di aggetti, edifici vicini o terreno, da 0 a 1. 0 significa nessun ombreggiamento e 1 completamente in ombra. Viene ridotto solo il sole diretto, non la radiazione diffusa. Le veneziane e gli screen qui sotto vengono registrati ma non sono usati nel calcolo.",
      },
      heatingCooling: {
        name: "Assegna all'apparecchiatura un nome chiaro che renda facile distinguere i componenti. Il nome viene utilizzato principalmente per l'identificazione nel progetto.",
        type: 'Il tipo descrive di che genere di unità di riscaldamento o raffreddamento si tratta, ad esempio radiatore, riscaldamento a pavimento, pompa di calore o trave fredda. La scelta controlla quali campi sono rilevanti e come il sistema viene modellato.',
        energySource:
          "La fonte di energia è ciò che l'unità utilizza per produrre riscaldamento o raffreddamento, ad esempio elettricità, teleriscaldamento o una pompa di calore. Seleziona la fonte se il componente è collegato direttamente a una fonte specifica, altrimenti l'approvvigionamento energetico può essere descritto centralmente.",
        co2eEmissionFactor:
          "Il fattore di emissione di CO₂e indica quanta emissione di gas serra è associata all'energia utilizzata dall'unità, espressa per kWh. Indica un valore specifico se desideri calcolare le emissioni con precisione. Non influisce sul fabbisogno energetico stesso.",
        quantity:
          'Indica il numero di unità identiche se sono installate più unità identiche. Può rimanere vuoto se la potenza è indicata complessivamente.',
        power:
          "La potenza nominale è la massima resa di riscaldamento o raffreddamento dell'unità in kW. Viene utilizzata per valutare se il sistema ha la capacità di coprire il fabbisogno e come vengono prioritizzati più sistemi. Indica la potenza complessiva se più unità identiche vengono raggruppate.",
        systemEfficiency:
          "Il rendimento del sistema descrive quanta parte dell'energia fornita diventa effettivamente riscaldamento o raffreddamento utile, comprese le perdite di distribuzione e regolazione. Indica un valore migliore di quello standard se ne disponi. Spesso non necessario nella prima registrazione.",
        priority:
          "La priorità controlla l'ordine in cui i sistemi vengono messi in funzione quando più sistemi coprono lo stesso fabbisogno. Una priorità più bassa significa che il sistema viene usato per primo e il resto copre il carico di punta. Imposta questo se la zona ha più fonti di riscaldamento o raffreddamento.",
        cop: 'Il COP (Coefficient of Performance) è il rendimento della pompa di calore per il riscaldamento: il rapporto tra calore fornito ed elettricità assorbita. Un COP di 3 significa tre volte più calore che elettricità. Indica un valore specifico se ne disponi.',
        eer: "L'EER (Energy Efficiency Ratio) è il rendimento per il raffreddamento: il rapporto tra freddo fornito ed elettricità assorbita. Un valore più elevato significa un raffreddamento più efficiente. Indica un valore specifico se ne disponi.",
        nominalLoad:
          "Il carico nominale (0-1) descrive la quota della piena capacità a cui l'unità è dimensionata per funzionare normalmente. È un campo di dettaglio e di solito può rimanere al valore standard.",
        minimumLoad:
          "Il carico minimo (0-1) è la quota più bassa della piena capacità a cui l'unità può funzionare stabilmente prima di doversi accendere e spegnere. Indica un valore se desideri sovrascrivere lo standard.",
        degradeCoeff:
          "Il coefficiente di degrado (0-1) descrive di quanto cala il rendimento quando l'unità funziona a carico parziale anziché a piena potenza. Le unità a controllo inverter hanno di solito perdite minori. Spesso impostato automaticamente.",
        maxTemperatureSupplied:
          "La temperatura di mandata massima è la temperatura più alta che l'unità può fornire al sistema di emissione del calore. Determina se l'unità può coprire il fabbisogno di temperatura, ad esempio per radiatori che richiedono una temperatura di mandata elevata.",
      },
      domesticHotWater: {
        name: "Assegna un nome chiaro al componente dell'acqua calda sanitaria se registri più unità o sottosistemi.",
        heaterType:
          "Il tipo di riscaldamento descrive come viene riscaldata l'acqua calda sanitaria, ad esempio uno scaldabagno elettrico diretto, una pompa di calore o un'alimentazione centrale come il teleriscaldamento. La scelta influisce sia sul fabbisogno energetico sia sulle emissioni per l'acqua calda.",
        tapFrequency:
          "La frequenza di prelievo descrive quanto spesso e quanta acqua calda viene prelevata, e riflette il modello di utilizzo effettivo della zona. È un fattore importante del fabbisogno energetico calcolato per l'acqua calda.",
        tapCyclesPerDay:
          "Il numero di cicli di prelievo al giorno è quante volte viene prelevata acqua calda nell'arco di una giornata. Indica un valore se desideri sovrascrivere il profilo standard con un numero più preciso.",
        thermalZone:
          "Collega il sistema di acqua calda sanitaria alla zona termica che serve. Questo colloca correttamente il consumo di energia e l'eventuale emissione di calore nel modello.",
      },
      productionEquipment: {
        name: "Assegna un nome chiaro all'apparecchiatura di produzione. Utilizzato per identificare il carico nel progetto e nei report.",
        energySource:
          "La fonte di energia è ciò che l'apparecchiatura di produzione utilizza, ad esempio elettricità o gas. Viene utilizzata per distribuire il consumo di energia sul vettore corretto e per un eventuale calcolo delle emissioni.",
        power:
          "La potenza nominale è l'assorbimento di potenza tipico dell'apparecchiatura in kW. Insieme al programma operativo fornisce la base per calcolare il consumo di energia e l'emissione di calore verso la zona.",
        eligibleForHarvesting:
          "Il recupero di energia consiste nell'utilizzare il calore in eccesso dell'apparecchiatura per altri scopi, ad esempio il riscaldamento. Seleziona questo se l'apparecchiatura emette tale energia in eccesso, così il potenziale di recupero viene valutato.",
        operationalSchedule:
          "Il programma operativo descrive quando l'apparecchiatura è effettivamente in uso nell'arco del giorno e della settimana. Aggiungilo se l'apparecchiatura non segue il normale orario di funzionamento, per un calcolo più realistico del consumo di energia e dei carichi interni.",
      },
      hvac: {
        name: "Assegna alla centrale di ventilazione un nome chiaro. Il nome viene utilizzato per l'identificazione se l'edificio ha più centrali.",
        linkedZones:
          "Le zone collegate sono le zone termiche che la centrale di ventilazione serve con aria. La scelta è necessaria per distribuire correttamente i volumi d'aria, l'energia dei ventilatori e il recupero di calore tra le zone.",
        flowSfpSettings:
          "Qui inserisci i volumi d'aria e le ipotesi SFP della centrale. L'SFP (potenza specifica del ventilatore) esprime quanta potenza elettrica i ventilatori utilizzano per volume d'aria, ed è un'informazione fondamentale per il calcolo della ventilazione.",
        motorType:
          'Il tipo di motore, ad esempio AC o EC, influisce sul rendimento del ventilatore e su come la potenza varia a carico parziale. Seleziona il tipo se è noto per un calcolo più preciso.',
        sfp100:
          "L'SFP (potenza specifica del ventilatore) è il rapporto tra l'assorbimento di potenza dei ventilatori e il volume d'aria, espresso in kW per m³/s. Un SFP più basso significa un ventilatore più efficiente dal punto di vista energetico. Indica il valore al 100 % di funzionamento, è il parametro principale del calcolo della ventilazione.",
        sfp80:
          "L'SFP all'80 % di funzionamento descrive la potenza specifica del ventilatore quando la centrale funziona a volume d'aria ridotto. Indicalo se disponi di dati di carico parziale, altrimenti il campo può rimanere vuoto.",
        sfp60:
          "L'SFP al 60 % di funzionamento descrive la potenza specifica del ventilatore a un volume d'aria inferiore. Utilizzato solo per una modellazione più dettagliata del carico parziale.",
        sfp40:
          "L'SFP al 40 % di funzionamento. Indicalo se sono disponibili dati di carico parziale per un volume d'aria così basso.",
        sfp20:
          "L'SFP al 20 % di funzionamento. Indicalo se sono disponibili dati di carico parziale per un volume d'aria così basso.",
        fanPowerIn:
          "La potenza del ventilatore di mandata è l'assorbimento di potenza elettrica del ventilatore di mandata in kW. Indicala se la hai separatamente. Può normalmente rimanere vuota quando l'SFP è registrato, poiché la potenza viene allora calcolata da esso.",
        fanPowerOut:
          "La potenza del ventilatore di estrazione è l'assorbimento di potenza elettrica del ventilatore di estrazione in kW. Indicala se la hai separatamente. Utilizzata solo per una registrazione più dettagliata.",
        coverageArea:
          "La superficie di copertura è la superficie di pavimento che la centrale serve, in m². Indicala se la centrale copre solo una parte dell'edificio o della zona. Può spesso essere dedotta dalle zone collegate.",
        coverageVolume:
          "Il volume di copertura è il volume d'aria che la centrale serve, in m³. Indicalo se è noto. Utilizzato come campo di dettaglio per il dimensionamento della ventilazione.",
        airVolumeOperating:
          "La portata d'aria di mandata in funzionamento è il volume d'aria che la centrale fornisce durante il funzionamento normale, in m³/h. È un dato di input fondamentale per il fabbisogno di ventilazione, l'energia dei ventilatori e le batterie di riscaldamento e raffreddamento.",
        airVolumeCapacity:
          "La capacità dell'aria di mandata è il volume d'aria massimo che la centrale può fornire, in m³/h. Indicala se è nota. Utile per le valutazioni di capacità, ma non sempre necessaria.",
        airVolumeNonOperating:
          "La portata d'aria di mandata fuori funzionamento è il volume d'aria che la centrale fornisce quando l'edificio non è in uso, ad esempio in funzionamento notturno ridotto. Indicala se la centrale funziona con una portata d'aria ridotta per parte del tempo.",
        airVolumeExtractionOperating:
          "La portata d'aria di estrazione in funzionamento è l'aria che la centrale estrae dalle zone durante il funzionamento normale, in m³/h. Insieme alla portata d'aria di mandata descrive l'effettivo bilancio d'aria della centrale e influisce sull'energia dei ventilatori e sul recupero di calore.",
        airVolumeExtractionCapacity:
          "La capacità d'aria di estrazione è il volume d'aria massimo che la centrale può estrarre, in m³/h. Indicala se è nota. Utile per le valutazioni di capacità, ma non sempre necessaria.",
        airVolumeExtractionNonOperating:
          "La portata d'aria di estrazione fuori funzionamento è l'aria che la centrale estrae quando l'edificio non è in uso, ad esempio in abbassamento notturno o funzionamento ridotto. Indicala se la centrale funziona con una portata d'aria ridotta per parte del tempo.",
        supplyTemperature:
          "La temperatura dell'aria di mandata è la temperatura dell'aria che la centrale immette nella zona, in °C. I setpoint del programma operativo hanno la precedenza: questo valore viene usato solo per le ore in cui il programma non ha un setpoint. Per cambiare il setpoint di mandata, modificalo nel programma operativo.",
        heatRecoveryType:
          "Il recupero di calore riutilizza il calore dell'aria estratta per preriscaldare l'aria di mandata, riducendo il fabbisogno di riscaldamento. Seleziona il tipo installato, ad esempio rotore entalpico, scambiatore a piastre o recuperatore a batteria. La scelta è importante per il calcolo dell'energia recuperata.",
        efficiencyHR:
          "Il rendimento indica quale quota del calore dell'aria estratta l'unità di recupero trasferisce effettivamente all'aria di mandata, in percentuale. Un valore più elevato significa un minore fabbisogno di riscaldamento. Indica un valore documentato se ne disponi, altrimenti viene utilizzato un valore standard basato sul tipo selezionato.",
        frostProtection:
          "La protezione antigelo impedisce all'unità di recupero di ghiacciare a basse temperature esterne, ma in tali periodi può ridurre la quantità di calore recuperata. Seleziona questo se la centrale dispone di una protezione antigelo che influisce sul funzionamento o sul recupero di calore. Utile per una modellazione più precisa.",
        frostProtectionTemperature:
          'È la temperatura esterna alla quale si attiva la protezione antigelo. Al di sotto di questa temperatura il recupero viene ridotto o regolato per evitare la formazione di ghiaccio. Indica il valore se è noto, altrimenti viene utilizzato un valore standard.',
        measuredSupplyTemp:
          "La temperatura dell'aria di mandata misurata è la temperatura effettiva dell'aria che la centrale immette, rilevata durante un sopralluogo o una registrazione. Indicala se disponi di misurazioni sul campo. Utilizzata per il controllo qualità e una calibrazione più precisa del modello.",
        measuredExhaustTemp:
          "La temperatura dell'aria estratta misurata è la temperatura effettiva dell'aria estratta dalle zone, rilevata mediante misurazione sul campo. Indicala se disponi di tali misurazioni. Insieme alla temperatura dell'aria di mandata misurata serve per il controllo qualità.",
        dx: {
          name: "Un sistema DX (espansione diretta) è una batteria di raffreddamento o pompa di calore in cui il refrigerante evapora direttamente nel flusso d'aria, senza un circuito d'acqua intermedio. Assegna all'unità un nome chiaro per l'identificazione se la centrale dispone di tale unità DX integrata.",
          type: "Il tipo indica cosa può fare l'unità DX: solo raffreddamento, solo riscaldamento o entrambi (funzione pompa di calore). La scelta controlla quali campi di potenza e rendimento sono rilevanti.",
          heatingEffect:
            "La potenza di riscaldamento è il calore massimo che l'unità DX può fornire all'aria, in kW. Indicala se il sistema fornisce calore. Può rimanere vuota se l'unità è utilizzata solo per il raffreddamento.",
          coolingEffect:
            "La potenza di raffreddamento è il freddo massimo che l'unità DX può fornire all'aria, in kW. È normalmente il valore di capacità più importante per il funzionamento in raffreddamento.",
          seasonalCop:
            "Il COP stagionale è il rendimento medio dell'unità DX per il riscaldamento in una stagione: il rapporto tra calore fornito ed elettricità assorbita. Indicalo se l'unità è usata anche per il riscaldamento. Usa un valore standard se non è disponibile una documentazione precisa.",
          seasonalEer:
            "L'EER stagionale è il rendimento medio dell'unità DX per il raffreddamento in una stagione: il rapporto tra freddo fornito ed elettricità assorbita. Indicalo se è noto. Utilizzato per calcolare il consumo di elettricità per il raffreddamento.",
          systemEfficiency:
            "Il calcolo usa il rendimento di sistema come rendimento dell'unità DX stessa, in percentuale: 300 % significa tre volte più calore o freddo che elettricità. I campi COP/EER stagionali non sono ancora usati, quindi inserire qui il COP o l'EER in percentuale. Se lasciato vuoto, si usa il 100 %.",
          energySource:
            "La fonte di energia è ciò che l'unità DX utilizza per produrre riscaldamento o raffreddamento, normalmente elettricità. Viene utilizzata per la distribuzione dell'energia e per un eventuale calcolo delle emissioni.",
        },
        heatingBattery: {
          name: "Una batteria di riscaldamento nella ventilazione è uno scambiatore di calore nella centrale che riscalda l'aria di mandata, tipicamente alimentato con acqua calda da una caldaia o pompa di calore, oppure elettrico. Assegna alla batteria un nome chiaro se più batterie sono presenti nella stessa centrale o nello stesso edificio.",
          type: 'Il tipo di batteria indica come viene fornito il calore, ad esempio ad acqua (acqua calda attraverso la batteria) o elettrico. La scelta influisce sulla fonte di energia e sul rendimento.',
          power:
            "La potenza è il calore massimo che la batteria può apportare all'aria di mandata, in kW. Utilizzata per il controllo di capacità e il calcolo energetico.",
          systemEfficiency:
            'Il rendimento del sistema tiene conto delle perdite di distribuzione e regolazione fino alla batteria. Indica un valore se hai un dato migliore di quello standard, altrimenti il campo può rimanere vuoto.',
          energySource:
            "La fonte di energia è ciò che fornisce calore alla batteria di riscaldamento, ad esempio teleriscaldamento, caldaia, pompa di calore o elettricità. Viene utilizzata per la distribuzione dell'energia e per un eventuale calcolo delle emissioni.",
        },
        coolingBattery: {
          name: "Una batteria di raffreddamento nella ventilazione è uno scambiatore di calore nella centrale che raffredda l'aria di mandata, tipicamente alimentato con acqua refrigerata da un refrigeratore o tramite espansione diretta (DX). Assegna alla batteria un nome chiaro se sono presenti più batterie.",
          type: 'Il tipo indica come viene fornito il raffreddamento, ad esempio ad acqua (acqua refrigerata attraverso la batteria) o DX (espansione diretta). La scelta influisce sulla fonte di energia e sul rendimento.',
          power:
            "La potenza è il freddo massimo che la batteria può apportare all'aria di mandata, in kW. Utilizzata per il controllo di capacità e il calcolo energetico.",
          systemEfficiency:
            'Il rendimento del sistema tiene conto delle perdite aggiuntive di distribuzione e regolazione oltre alla prestazione nominale. Indica un valore se desideri includere tali perdite, altrimenti il campo può rimanere vuoto.',
          eer: "L'EER (Energy Efficiency Ratio) è il rendimento della batteria di raffreddamento: il rapporto tra freddo fornito ed elettricità assorbita. Indicalo se è noto. Utilizzato per calcolare il consumo di elettricità per il raffreddamento.",
          energySource:
            "La fonte di energia è ciò che fornisce raffreddamento alla batteria di raffreddamento, ad esempio un refrigeratore, teleraffrescamento o DX. Viene utilizzata per la distribuzione dell'energia e per un eventuale calcolo delle emissioni.",
        },
        naturalVentilation:
          "La ventilazione naturale è il ricambio d'aria provocato dal vento e dalle differenze di temperatura attraverso finestre, griglie o condotti, senza ventilatori. Attiva questo se la zona o la centrale dispone di ventilazione naturale da includere nel modello.",
        operationalSchedule:
          "Un programma di funzionamento descrive quando la ventilazione è in funzione nell'arco del giorno e della settimana. Inserisci un programma per la ventilazione naturale o il funzionamento della centrale se questo si discosta dagli orari di funzionamento standard.",
        operationalScheduleExtra:
          'Usa un programma aggiuntivo quando la stessa centrale o funzione di ventilazione ha più periodi di funzionamento con esercizio diverso, ad esempio stagionale. Ogni programma copre il proprio periodo.',
      },
      centralEnergy: {
        name: "Un modulo di energia centralizzata è una centrale energetica comune che alimenta più zone o funzioni, ad esempio una centrale termica o una centrale frigorifera. Assegnale un nome chiaro. Il nome serve solo per l'identificazione.",
        mode: "La modalità indica se la centrale fornisce riscaldamento, raffreddamento, acqua calda o combinazioni di questi. È un'impostazione fondamentale che controlla come la centrale viene utilizzata nel modello.",
        thermalZone:
          'Una centrale può essere collegata a una zona termica in modo che la temperatura ambiente intorno alla centrale segua quella zona, il che influisce su rendimento e perdite. Collegala a una zona pertinente se la posizione o la temperatura ambiente è importante per il calcolo, altrimenti può rimanere autonoma.',
        ambientTemperature:
          'La temperatura ambiente è la temperatura del locale in cui si trova la centrale, ad esempio un locale tecnico. Viene utilizzata solo quando la centrale non è collegata a una zona termica e influisce sulle perdite della centrale e dei serbatoi di accumulo. Se è selezionata una zona, la temperatura viene presa da lì.',
        sourceName:
          "Assegna alla fonte di energia un nome chiaro in modo che sia facile da riconoscere se la centrale ha più fonti di energia. Il nome serve solo per l'identificazione.",
        usage:
          "Queste opzioni controllano ciò che la fonte di energia copre effettivamente: riscaldamento, raffreddamento e/o acqua calda sanitaria. Seleziona i fabbisogni a cui la fonte contribuisce. A controllo inverter significa che l'unità può modulare la potenza, il che offre un rendimento migliore a carico parziale.",
        heatPump: {
          type: "Il tipo di pompa di calore descrive da dove la pompa di calore preleva l'energia e dove la fornisce: aria-acqua preleva energia dall'aria esterna e la fornisce a un sistema ad acqua, acqua glicolata-acqua attinge dal terreno, dalla roccia o dall'acqua tramite un collettore, e aria-aria riscalda direttamente l'aria interna. La scelta influisce sul rendimento e su quali campi aggiuntivi vengono mostrati.",
          co2eEmissionFactor:
            "Il fattore di emissione di CO₂e indica quanta emissione di gas serra è associata all'energia utilizzata dalla pompa di calore, espressa per kWh. Indica un valore specifico solo se desideri calcolare le emissioni con precisione. Non influisce sul fabbisogno energetico stesso.",
          heatingCapacity:
            'La capacità di riscaldamento è la potenza termica nominale della pompa di calore in kW, ovvero quanto calore può fornire in condizioni normali. È il valore di capacità più importante e serve a valutare se la pompa copre il fabbisogno di riscaldamento.',
          nominalLoad:
            'Il carico nominale (0-1) è la quota della piena capacità a cui la pompa di calore è dimensionata per funzionare normalmente. Indicalo se la documentazione lo riporta separatamente. Utilizzato per una modellazione dettagliata a carico parziale.',
          minimumLoad:
            'Il carico minimo (0-1) è la quota più bassa della piena capacità a cui la pompa di calore può funzionare stabilmente prima di doversi accendere e spegnere. Indicalo se la pompa può modulare e questo è noto.',
          degradeCoeff:
            'Il coefficiente di degrado (0-1) descrive di quanto cala il rendimento quando la pompa di calore funziona a carico parziale anziché a piena potenza. Indicalo se sono disponibili dati del produttore o calcoli. Normalmente può rimanere vuoto; viene quindi impostato a 0,8 secondo NS 3031, o 0,6 per le unità a controllo inverter.',
          maxTemperatureSupplied:
            'La temperatura massima fornita è la temperatura di mandata più calda che la pompa di calore può fornire al sistema di riscaldamento, in °C. Le pompe di calore perdono rendimento a temperature di mandata elevate. Serve a valutare se la pompa copre il fabbisogno di temperatura, ad esempio per radiatori che richiedono una temperatura elevata.',
          cop: 'Il COP (Coefficient of Performance) è il rendimento della pompa di calore per il riscaldamento: il rapporto tra calore fornito ed elettricità assorbita. Un COP di 3 significa tre volte più calore che elettricità. Indica un valore specifico se ne disponi, altrimenti vengono utilizzati valori standard.',
          liquidSource:
            'La fonte liquida è il mezzo da cui la pompa di calore acqua glicolata-acqua attinge energia tramite un collettore, ad esempio terreno, roccia, acqua dolce o acqua di mare. La fonte influisce sulla temperatura della fonte disponibile e quindi sul rendimento.',
          sourceTemperature:
            'La temperatura della fonte è la temperatura del liquido che proviene dalla fonte ed entra nella pompa di calore, in °C. Una temperatura della fonte più elevata dà un rendimento migliore. Indicala se è nota da misurazione o da indagine geologica.',
          sourceYearlyAverageTemperature:
            'La temperatura media annua è la temperatura media della fonte nel corso di un anno, in °C. Viene utilizzata come riferimento per calcolare le prestazioni stagionali della pompa di calore. Indicala se è nota, altrimenti vengono utilizzati valori tipici per la fonte selezionata.',
          liquidMaxTemperature:
            "È la temperatura più alta che la fonte raggiunge nel corso dell'anno, in °C. Insieme alla media annua e all'ampiezza descrive come la temperatura della fonte varia nel corso della stagione, il che influisce sul rendimento.",
          sourceTemperatureAmplitude:
            "L'ampiezza di temperatura descrive di quanto la temperatura della fonte varia sopra e sotto la media annua nel corso dell'anno, in °C. Un'ampiezza maggiore significa una maggiore variazione stagionale del rendimento. Indicala se è nota, altrimenti vengono utilizzati valori tipici per la fonte.",
          energyWellDimensioning:
            "Valori indicativi per la temperatura media annua e l'ampiezza annua dei pozzi geotermici (perforazioni). Scegli la descrizione che meglio corrisponde all'uso e al dimensionamento del pozzo; i valori di temperatura vengono quindi impostati automaticamente in base al clima locale.",
          waterSourceDepth:
            "Valori indicativi per la temperatura media annua e l'ampiezza annua del prelievo di calore in mare o in acqua dolce. Scegli la profondità del prelievo; i valori di temperatura vengono quindi impostati automaticamente in base al clima locale.",
        },
        districtHeating: {
          maxCapacity:
            "La capacità massima è la potenza più alta che l'allacciamento al teleriscaldamento o teleraffrescamento può fornire all'edificio, in kW. Indicala se è nota da documentazione o dati di impianto. Serve a valutare se la fonte copre il fabbisogno di potenza.",
          efficiency:
            "Il rendimento descrive quanta parte dell'energia fornita dalla rete di teleriscaldamento diventa effettivamente calore utile nell'edificio, dopo le perdite nello scambiatore e nella distribuzione. Indica un valore complessivo se desideri sovrascrivere i valori standard della centrale.",
          temperatureFromSource:
            'La temperatura dalla fonte è la temperatura di mandata che la rete di teleriscaldamento o teleraffrescamento fornisce allo scambiatore, in °C. Indicala se è nota. Fornisce una descrizione più realistica del funzionamento e del rendimento della centrale.',
          heatExchangerLoss:
            "Lo scambiatore di calore trasferisce energia dalla rete di teleriscaldamento al sistema proprio dell'edificio, e una parte dell'energia viene persa lungo il percorso. Seleziona il livello di isolamento e l'intervallo di temperatura di uscita per descrivere la perdita in modo più dettagliato, oppure indica direttamente il coefficiente di perdita se esiste un valore documentato. Lascia i campi vuoti per usare i valori standard.",
          distributionHeatLoss:
            "La perdita di calore di distribuzione è l'energia persa nella rete di tubazioni tra la centrale e il sistema dell'edificio. Seleziona l'intervallo di temperatura di mandata per la distribuzione per descrivere la perdita in modo più dettagliato, oppure indica direttamente il coefficiente di perdita se è noto. Lascia i campi vuoti per usare i valori standard.",
          coolingHeatExchanger:
            "Lo scambiatore di raffreddamento trasferisce il raffreddamento dal teleraffrescamento o dalla centrale frigorifera al sistema dell'edificio, e una parte dell'energia viene persa. Seleziona il livello di isolamento se il lato raffreddamento deve essere modellato in modo più dettagliato, oppure indica direttamente il valore U se è noto. Lascia i campi vuoti per usare i valori standard.",
          co2eEmissionFactor:
            "Il fattore di emissione di CO₂e indica quanta emissione di gas serra è associata all'energia del teleriscaldamento o teleraffrescamento, espressa in grammi per kWh. Indica un valore specifico se desideri usare il dato di emissione reale della rete. Influisce solo sul calcolo delle emissioni, non sul fabbisogno energetico stesso.",
          energyPrice:
            "Il prezzo dell'energia è il costo per kWh dell'energia fornita dal teleriscaldamento o teleraffrescamento. Indica un prezzo specifico se desideri calcoli dei costi con prezzi reali, altrimenti il campo può rimanere vuoto. Influisce solo sulle cifre di costo, non sull'energia o sulle emissioni.",
        },
        combustionBoiler: {
          boilerType:
            "Il tipo di caldaia descrive di che genere di caldaia a combustione si tratta, ad esempio gasolio, gas o biomassa. Seleziona quello che descrive meglio l'impianto. La scelta controlla le ipotesi standard come rendimento e livello di emissione.",
          heatingCapacity:
            'La capacità di riscaldamento è la potenza termica nominale della caldaia in kW, ovvero quanta potenza può fornire in condizioni normali. È il valore principale per valutare se la caldaia copre il fabbisogno di potenza.',
          performance:
            'La prestazione indica il livello di rendimento nominale della caldaia, ovvero con quanta efficienza il combustibile viene convertito in calore utile. Seleziona o indica il livello se è documentato per la caldaia, altrimenti vengono utilizzati valori standard.',
          fuelSource:
            'La fonte di combustibile è ciò che la caldaia brucia, ad esempio gasolio, gas o biocombustibile. La scelta determina il contenuto energetico standard e il fattore di emissione del combustibile, e influisce quindi sia sul calcolo energetico sia su quello delle emissioni.',
          fuelEnergyContent:
            'Il contenuto energetico è la quantità di energia che il combustibile contiene per unità, ad esempio kWh per litro. Indica un valore specifico se desideri ipotesi più precise rispetto ai valori standard del combustibile selezionato.',
          co2eEmissionFactor:
            'Il fattore di emissione di CO₂e indica quanta emissione di gas serra produce la combustione del combustibile, espressa in grammi per kWh. Indica un valore specifico se desideri un calcolo preciso delle emissioni. Influisce solo sul calcolo delle emissioni, non sul fabbisogno energetico.',
          efficiencyAtLowerLoad:
            'Questa è la potenza termica della caldaia quando funziona a circa il 30 % del carico pieno, in chilowatt. Il valore è obbligatorio insieme al valore a pieno carico affinché la simulazione possa modellare il comportamento a carico parziale della caldaia.',
          effectAtFullLoad:
            'Questa è la potenza termica della caldaia a pieno carico in chilowatt, cioè quanta potenza fornisce al massimo regime. Il valore è obbligatorio affinché la simulazione dimensioni correttamente la caldaia.',
          isCondensing:
            'Una caldaia a condensazione recupera anche il calore del vapore acqueo dei fumi e raggiunge così un rendimento più elevato di una caldaia tradizionale. Seleziona questo se la caldaia è a condensazione.',
          isCHP:
            "Un impianto di cogenerazione (CHP) produce contemporaneamente sia elettricità sia calore dallo stesso combustibile, garantendo un elevato utilizzo energetico complessivo. Seleziona questo se l'impianto è un impianto CHP; vengono quindi mostrate impostazioni CHP dedicate.",
          scheduleStart:
            "L'ora di inizio è quando inizia la stagione di funzionamento della caldaia, indicata come giorno e mese. Compila questo se la caldaia non funziona in continuo o non segue il profilo di funzionamento standard, ad esempio una caldaia usata solo durante la stagione di riscaldamento.",
          scheduleEnd:
            "L'ora di fine è quando termina la stagione di funzionamento della caldaia, indicata come giorno e mese. Da compilare insieme all'ora di inizio per descrivere il periodo in cui la caldaia è in funzione.",
          seasonalMeanTemp:
            "La temperatura media stagionale è la temperatura esterna media nel corso della stagione di funzionamento, in °C. Indicala se l'impianto deve essere descritto con ipotesi di temperatura più dettagliate rispetto allo standard.",
          temperatureSupply:
            "La temperatura di mandata è la temperatura dell'acqua che la caldaia invia al sistema di riscaldamento, in °C. Una temperatura di mandata più bassa dà spesso un rendimento migliore, soprattutto per le caldaie a condensazione. Indicala se è nota.",
          temperatureReturn:
            "La temperatura di ritorno è la temperatura dell'acqua che torna alla caldaia dal sistema di riscaldamento, in °C. Per le caldaie a condensazione una temperatura di ritorno bassa è importante per ottenere la condensazione e un rendimento elevato. Indicala se è nota.",
        },
        electricBoiler: {
          maxCapacity:
            'La capacità massima è la potenza più alta che la caldaia elettrica può fornire, in kW. È il valore principale per valutare se la caldaia copre il fabbisogno di potenza.',
          insulationGrade:
            "Il grado di isolamento descrive quanto bene è isolata la caldaia stessa e determina quanta energia termica perde verso l'ambiente mentre è accesa. Seleziona un grado se desideri una modellazione più precisa della dispersione di calore della caldaia.",
          efficiency:
            "Il rendimento descrive quanta parte dell'elettricità fornita diventa calore utile, dopo le perdite nella caldaia. Le caldaie elettriche hanno normalmente un rendimento elevato. Indica un valore se desideri sovrascrivere le ipotesi standard.",
          co2eEmissionFactor:
            "Il fattore di emissione di CO₂e indica quanta emissione di gas serra è associata all'elettricità utilizzata dalla caldaia, espressa in grammi per kWh. Indica un valore specifico se desideri un calcolo preciso delle emissioni. Influisce solo sul calcolo delle emissioni, non sul fabbisogno energetico.",
          temperatureSupply:
            "La temperatura di mandata è la temperatura dell'acqua che la caldaia invia al sistema di riscaldamento, in °C. Influisce su quali emettitori di calore la caldaia può servire e sulla dispersione di calore del sistema. Indicala se è nota.",
          temperatureReturn:
            "La temperatura di ritorno è la temperatura dell'acqua che torna alla caldaia dal sistema di riscaldamento, in °C. Insieme alla temperatura di mandata descrive il livello di temperatura del sistema. Indicala se è nota.",
        },
        solarThermal: {
          solarType:
            "Il tipo di collettore solare descrive il principio del collettore, ad esempio collettore piano o a tubi sottovuoto. I collettori a tubi sottovuoto offrono generalmente prestazioni migliori a basse temperature esterne. La scelta influisce sulle ipotesi standard di resa dell'impianto.",
          azimuth:
            "L'azimut è l'orientamento dei collettori rispetto ai punti cardinali in gradi, dove 0 significa generalmente pieno sud. Descrive in quale direzione sono rivolti i collettori e influisce fortemente sulla quantità di energia solare captata.",
          tilt: "L'inclinazione è l'angolo dei collettori rispetto all'orizzontale in gradi, dove 0 è piano e 90 verticale. Insieme all'azimut determina quanta radiazione solare ricevono i collettori nel corso dell'anno.",
          adjustmentFactor:
            'Il fattore di regolazione aumenta o riduce la resa solare calcolata per tenere conto delle condizioni locali come ombreggiamento o sporcizia. Indica un valore solo se desideri correggere il calcolo standard; altrimenti lascia il campo vuoto.',
          performance:
            "La prestazione indica il livello di rendimento nominale o di capacità dell'impianto solare termico, ovvero con quanta efficienza i collettori convertono la radiazione solare in calore utile. Seleziona o indica il livello se è noto dalla documentazione, altrimenti vengono utilizzati valori standard.",
          pipeLength:
            'La lunghezza delle tubazioni è la lunghezza totale dei tubi tra i collettori e il serbatoio di accumulo, in metri. Tubi più lunghi perdono più calore. Indicala insieme al tipo di isolamento dei tubi se desideri calcolare le perdite delle tubazioni in modo più dettagliato.',
          pipeInsulationType:
            'Il tipo di isolamento dei tubi descrive quanto bene sono isolati i tubi tra i collettori e il serbatoio, il che fissa la dispersione di calore standard per metro di tubo. Selezionalo se noto, altrimenti viene utilizzato un valore standard.',
          pipeUValue:
            'Il valore U dei tubi indica quanta energia termica i tubi del circuito dei collettori perdono per metro e grado di differenza di temperatura (W/mK). Un valore più basso significa un isolamento migliore. Indicalo se è noto, altrimenti viene derivato dal tipo di isolamento dei tubi selezionato.',
          collectorArea:
            'La superficie di captazione è la superficie attiva totale dei collettori solari, in m². È un dato di input fondamentale per il calcolo della produzione, poiché una maggiore superficie di collettori fornisce più energia solare.',
          tankSpiralPlacementFactor:
            "Il fattore di posizionamento della serpentina del serbatoio descrive dove si trova la serpentina solare nel serbatoio di accumulo, il che influisce sull'efficacia con cui il calore solare viene trasferito all'acqua. Indica un valore se disponi di dati dettagliati per il sistema, altrimenti viene utilizzato un valore standard.",
          temperatureColdWater:
            "La temperatura dell'acqua fredda è la temperatura dell'acqua fornita al sistema prima di essere riscaldata dai collettori, in °C. Una temperatura dell'acqua fredda più bassa dà una resa solare più elevata. Indica un valore se desideri sovrascrivere il valore standard.",
          percentageOfCollectorLoopOutside:
            "Indica quanta parte del circuito dei collettori (tubi e componenti) si trova all'esterno, in percentuale. I tubi che corrono all'esterno perdono più calore. Indica un valore se questo è rilevante per il calcolo delle perdite.",
          collectorSpecs:
            "Questi valori costituiscono la curva di rendimento del collettore, tratta dalla scheda tecnica del prodotto o dal certificato Solar Keymark. η₀ è il rendimento ottico in assenza di differenza di temperatura, mentre i coefficienti di dispersione a₁ e a₂ descrivono quanto rapidamente il rendimento cala quando il collettore diventa più caldo dell'ambiente. Indica i valori se esiste documentazione, altrimenti vengono utilizzati valori standard.",
          snowCoverageMonths:
            'Seleziona in quali mesi i collettori solari sono normalmente coperti di neve. In questi mesi i collettori producono poca o nessuna energia, il che offre un calcolo annuale più realistico in cui la neve influisce sulla produzione.',
          insulationFactorForCollectionLoop:
            'Il fattore di isolamento del circuito di captazione descrive quanto bene sono isolati nel complesso i tubi e i componenti del circuito solare. Seleziona un livello se desideri un calcolo più preciso della dispersione di calore del circuito, altrimenti viene utilizzato un valore standard.',
        },
        otherSource: {
          fuelType:
            "Il tipo di combustibile è il vettore energetico che questa fornitura utilizza, ad esempio gasolio, gas, biocombustibile, teleriscaldamento o elettricità. La scelta determina il fattore di emissione standard e come l'energia viene contabilizzata.",
          maxCapacity:
            'La capacità massima è la potenza più alta che questa fonte di energia può fornire, in kW. È il valore principale per valutare se la fonte copre il fabbisogno di potenza.',
          efficiency:
            "Il rendimento descrive quanta parte dell'energia fornita diventa calore o freddo utile, dopo le perdite nella fonte. Indica un valore se è noto, altrimenti viene utilizzata un'ipotesi standard.",
          co2eEmissionFactor:
            "Il fattore di emissione di CO₂e indica quanta emissione di gas serra è associata all'energia utilizzata da questa fonte, espressa in grammi per kWh. Indica un valore specifico se desideri un calcolo preciso delle emissioni. Influisce solo sul calcolo delle emissioni, non sul fabbisogno energetico.",
          energyPrice:
            "Il prezzo dell'energia è il costo per kWh di energia proveniente da questa fonte. Indica un prezzo specifico se desideri calcoli dei costi con prezzi reali, altrimenti il campo può rimanere vuoto. Influisce solo sulle cifre di costo, non sull'energia o sulle emissioni.",
        },
        accumulationTank: {
          purpose:
            'Un serbatoio di accumulo immagazzina calore o freddo in modo che produzione e consumo possano essere spostati nel tempo. Seleziona lo scopo, ad esempio accumulo di calore, accumulo di freddo o acqua calda, che descrive la funzione del serbatoio nel sistema.',
          volume:
            'Il volume è la capacità di accumulo del serbatoio in litri ed è il parametro principale per quanta energia termica o freddo il serbatoio può immagazzinare. Indicalo se è presente un serbatoio di accumulo.',
          insulation:
            "Il livello di isolamento descrive quanto bene il serbatoio è isolato e determina quanta energia termica viene persa verso l'ambiente. Seleziona il livello o il tipo se noto. Utilizzato per stimare o sovrascrivere la dispersione di calore del serbatoio.",
          heatLoss:
            "La dispersione di calore (W/K) indica quanta potenza il serbatoio perde verso l'ambiente per grado di differenza di temperatura. Indica un valore documentato se ne disponi. Normalmente può rimanere vuoto se volume e isolamento standard sono sufficienti.",
          setpoint:
            'La temperatura di setpoint è la temperatura di accumulo desiderata nel serbatoio, in °C. Determina quanto caldo o freddo viene mantenuto il fluido e influisce sia sulle perdite sia sulla capacità.',
          maxTemp:
            'La temperatura massima è la temperatura più alta che il serbatoio può raggiungere, in °C. Indicala se è nota o rilevante per la regolazione.',
          minTemp:
            'La temperatura minima è la temperatura più bassa a cui il serbatoio può scendere, in °C. Indicala se è nota o rilevante per la regolazione.',
          minTempDhw:
            "La temperatura minima è la temperatura più bassa a cui il serbatoio può scendere, in °C. Per i serbatoi dell'acqua calda sanitaria va mantenuta ad almeno 70 °C per prevenire la proliferazione della legionella.",
        },
      },
      excessEnergy: {
        medium:
          "Il medium è ciò in cui scorre l'energia in eccesso: aria, ad esempio un condotto di estrazione, o liquido, ad esempio una tubazione di acque reflue. La scelta determina quali campi vengono mostrati e come viene calcolata l'energia disponibile.",
        name: "Assegna alla fonte di energia in eccesso un nome chiaro. Il nome serve a identificare le potenziali fonti per il recupero, ad esempio l'aria estratta da una cucina o il calore di scarto di un processo.",
        ductShape:
          "Seleziona il medium e la forma del condotto per la fonte. La forma del condotto, ad esempio rotonda o rettangolare, viene utilizzata insieme alle dimensioni per calcolare la sezione e quindi il flusso di energia disponibile quando l'energia in eccesso è prelevata dall'aria.",
        ductWidthDiameter:
          "Indica la larghezza o il diametro del condotto in mm se è noto. Utilizzato insieme alla forma del condotto e, eventualmente, all'altezza, alla velocità dell'aria o alla portata volumetrica per calcolare quanta aria scorre nel condotto.",
        height:
          "Indica l'altezza del condotto in mm se la forma del condotto lo richiede, ad esempio per un condotto rettangolare. Insieme alla larghezza fornisce la sezione del condotto.",
        airspeed:
          "La velocità dell'aria è la rapidità con cui l'aria scorre nel condotto, in m/s. Indicala se la portata volumetrica non è nota direttamente; la portata d'aria viene allora calcolata dalla velocità e dalla sezione del condotto.",
        exhaustTempAir:
          "La temperatura dell'aria estratta è la temperatura del flusso d'aria da cui viene prelevata l'energia in eccesso, in °C. La temperatura è determinante per valutare quanta energia può essere recuperata; una temperatura più alta fornisce più calore disponibile.",
        exhaustTempLiquid:
          "Indica la temperatura del flusso di liquido da cui viene prelevata l'energia in eccesso, in °C. La temperatura è determinante per valutare quanta energia può essere recuperata dal liquido.",
        volumeFlowAir:
          "La portata volumetrica è quanta aria passa all'ora, in m³/h. Insieme alla temperatura determina quanta energia è disponibile per il recupero. Indicala se è nota, altrimenti può essere calcolata dalla geometria del condotto e dalla velocità dell'aria.",
        volumeFlowLiquid:
          "La portata volumetrica è quanto liquido passa all'ora, in L/h. Insieme alla temperatura determina quanta energia è disponibile per il recupero. Indicala se è nota.",
      },
      solarPv: {
        panelAngle:
          "L'inclinazione dei pannelli solari misurata rispetto all'orizzontale, in gradi. Un pannello appoggiato in piano sul tetto è a 0° e un pannello in posizione verticale a 90°. L'inclinazione determina quanto direttamente la luce solare colpisce i pannelli nel corso dell'anno e influisce quindi notevolmente sulla produzione annua stimata.",
        name: "Un nome chiaro e riconoscibile per questo impianto fotovoltaico. Viene usato per identificare l'impianto in elenchi, risultati e report, il che è utile quando un edificio dispone di più impianti fotovoltaici distinti.",
        panelArea:
          "La superficie attiva dei pannelli solari, in metri quadrati. Indicare la superficie di un singolo pannello oppure la superficie complessiva dell'intero impianto, a seconda di come viene registrato l'impianto, e far corrispondere Quantità a questa scelta. Insieme al rendimento dei pannelli, la superficie è uno dei dati centrali che determinano quanta elettricità il sistema può produrre.",
        quantity:
          "Il numero di pannelli solari dell'impianto, se noto. Viene combinato con la superficie dei pannelli e il rendimento per stimare la capacità installata e deve corrispondere al modo in cui è stata inserita la superficie: usare il numero di pannelli quando la superficie pannelli è per pannello e 1 quando è la superficie totale dell'impianto.",
        yearInstalled:
          "L'anno di messa in servizio dell'impianto fotovoltaico. Viene registrato per l'ispezione, ma il calcolo non lo utilizza: l'invecchiamento dei pannelli è sempre calcolato su una durata fissa di 30 anni, con la perdita di degrado annua.",
        soilingLocation:
          "Il tipo di sito che determina la velocità con cui polvere, polline e inquinamento si depositano sui pannelli. Scegliendo una posizione, ad esempio urbana, rurale o un'altra esposizione, viene caricato un profilo mensile di sporcamento standard per quell'ambiente, che è poi possibile regolare con precisione mese per mese qui sotto.",
        monthlySoiling:
          "Lo sporcamento è la perdita di produzione causata da sporco, polvere, neve e inquinamento sulla superficie dei pannelli e varia nel corso dell'anno. La selezione di una posizione compila un profilo standard semplificato; inserisci qui il tuo valore per ogni mese se desideri sostituire tale profilo con dati specifici del sito.",
        cellType:
          "La tecnologia fotovoltaica dei pannelli, ad esempio silicio monocristallino o policristallino. Il tipo di cella determina l'efficienza con cui i pannelli convertono la luce solare in elettricità, quindi la sua scelta imposta un rendimento nominale predefinito rappresentativo che è comunque possibile modificare.",
        nominalEfficiency:
          'La quota di energia solare incidente che i pannelli convertono in elettricità in condizioni di prova standard, espressa come numero decimale (ad esempio 0,20 per il 20 %). Inserisci il valore documentato della scheda tecnica se è noto; in caso contrario viene utilizzato il valore predefinito del tipo di cella scelto.',
        panelAzimuth:
          "L'orientamento dei pannelli rispetto ai punti cardinali, in gradi da 0 a 360 (il sud è intorno a 180° nell'emisfero settentrionale). L'azimut, insieme all'inclinazione, determina quanta parte del percorso del sole i pannelli captano durante il giorno e l'anno e influisce quindi direttamente sulla produzione stimata.",
        shadingFactor:
          "La quota di luce solare che i pannelli perdono per l'ombreggiamento di edifici vicini, terreno o vegetazione, da 0 a 1. 0 significa nessun ombreggiamento e 1 completamente in ombra, quindi il valore predefinito 0,05 è una perdita del 5 %. Il valore viene registrato, ma il calcolo non lo utilizza ancora.",
        mountingType:
          "Come sono montati i pannelli, ad esempio integrati nel tetto o autoportanti con un'intercapedine d'aria. Il tipo di montaggio determina quanto bene i pannelli vengono raffreddati dall'aria circostante, dato che confluisce nel modello più dettagliato di temperatura e perdite dei pannelli. Selezionalo se desideri questo livello di dettaglio.",
        windExposure:
          "Quanto l'impianto è esposto al vento. Il vento raffredda i pannelli e ne abbassa la temperatura di esercizio, migliorando il rendimento, quindi questo dato è usato insieme al tipo di montaggio nel modello più dettagliato di temperatura dei pannelli. Selezionalo se è noto.",
        heatLossFactor:
          "La facilità con cui i pannelli cedono calore all'ambiente circostante, in W/m²K. Normalmente viene ricavato dal tipo di montaggio e dall'esposizione al vento, ma puoi inserire qui un valore per sostituire queste ipotesi standard e controllare come viene modellata la temperatura dei pannelli.",
        inverterEfficiency:
          "La quota di corrente continua proveniente dai pannelli che l'inverter restituisce come corrente alternata utilizzabile, come numero decimale (ad esempio 0,945). Rappresenta la perdita di conversione dell'inverter; inserisci il valore documentato della scheda tecnica se è noto.",
        degradationLoss:
          "Il calo graduale e permanente della produzione dei pannelli con l'invecchiamento dei moduli, come numero decimale (ad esempio 0,005 per lo 0,5 % all'anno). Inseriscilo se desideri modellare con maggiore precisione il calo di prestazioni nell'arco di vita dell'impianto.",
        inverterLoss:
          "Perdite aggiuntive legate all'inverter e al suo funzionamento, come numero decimale. Utilizza questo campo quando desideri registrare le perdite legate all'inverter separatamente dal rendimento dell'inverter anziché accorparle in un unico valore.",
        transmissionProduct:
          'Un fattore combinato (da 0 a 1) per le perdite ottiche quando la luce attraversa il vetro di copertura del pannello e raggiunge le celle, come riflessione e assorbimento. Inseriscilo come numero decimale quando il metodo di calcolo scelto utilizza questo termine.',
        temperatureCoefficient:
          'Di quanto la produzione del pannello varia con la temperatura, in %/°C. È normalmente negativo perché la produzione diminuisce quando i pannelli si riscaldano oltre la loro temperatura di prova nominale. Inserisci il valore documentato della scheda tecnica se ne esiste uno per questi pannelli.',
        incidentAngleModifier:
          "Un fattore (da 0 a 1) che tiene conto delle perdite di riflessione aggiuntive quando la luce solare colpisce il pannello di sbieco anziché frontalmente. Inseriscilo come numero decimale se desideri utilizzare il modello solare più dettagliato che considera questi effetti dell'angolo di incidenza.",
      },
      battery: {
        name: 'Un nome chiaro e riconoscibile per questa batteria. Serve a identificare la batteria in elenchi, risultati e report, utile quando un edificio ha più batterie.',
        maxCapacity:
          'La quantità totale di energia che la batteria può immagazzinare, in kWh. È la capacità nominale del sistema di accumulo e fissa il limite di quanto surplus solare può essere immagazzinato per un uso successivo.',
        maxChargePower:
          'La potenza massima con cui la batteria può caricarsi, in kW. Limita la velocità con cui la batteria può assorbire il surplus solare o la corrente dalla rete.',
        maxDischargePower:
          "La potenza massima che la batteria può restituire all'edificio, in kW. Limita quanta parte del carico dell'edificio la batteria può coprire in ogni momento.",
        chargeEfficiency:
          "La quota dell'energia inviata alla batteria che viene effettivamente immagazzinata, tra 0 e 1. Lascia 0 per usare il valore predefinito tipico delle batterie agli ioni di litio.",
        dischargeEfficiency:
          "La quota dell'energia immagazzinata che viene effettivamente erogata quando la batteria si scarica, tra 0 e 1. Lascia 0 per usare il valore predefinito tipico delle batterie agli ioni di litio.",
        minStateOfCharge:
          'Il livello più basso a cui la batteria può scaricarsi, come quota della capacità totale tra 0 e 1. Mantenere una riserva protegge la durata della batteria. Lascia 0 per usare il valore predefinito.',
        maxStateOfCharge:
          'Il livello più alto a cui la batteria può caricarsi, come quota della capacità totale tra 0 e 1. Caricare leggermente sotto il massimo protegge la durata della batteria. Lascia 0 per usare il valore predefinito.',
        peakShavingThreshold:
          "L'importazione dalla rete sotto cui la batteria cerca di mantenere l'edificio, in kW. Quando l'edificio preleverebbe dalla rete più di questo valore, la batteria si scarica per coprire la differenza. Lascia 0 per disattivare la riduzione dei picchi; la batteria allora immagazzina solo il surplus solare e copre i deficit.",
        preChargeStateOfCharge:
          'Il livello a cui la batteria si precarica dalla rete nelle ore tranquille, come quota della capacità totale tra 0 e 1, per essere pronta al picco successivo. Usato solo quando è impostata una soglia di riduzione dei picchi. Lascia 0 per disattivare la precarica.',
      },
    },
  },

  // Page titles
  title: 'Ispezioni edifici',
  sidebarTitle: 'Ispezione',
  new: 'Nuova ispezione',
  edit: 'Modifica ispezione',

  // List page
  fetchError: 'Impossibile caricare le ispezioni.',
  noInspections: 'Nessuna ispezione trovata.',
  createNew: 'Nuova ispezione',
  confirmDeleteTitle: 'Elimina ispezioni',
  confirmDeleteDescription: 'Sei sicuro di voler eliminare questa ispezione?',
  duplicate: 'Duplica',
  duplicating: "Duplicazione dell'ispezione...",
  duplicateSuccess: 'Ispezione duplicata',
  duplicateError: "Impossibile duplicare l'ispezione",
  renameInspection: 'Rinomina ispezione',

  // Common. TODO: add way more common translations for all languages. Then compare to global common dash lang and start using those.
  common: {
    // generic
    custom: 'Personalizzato',
    standard: 'Standard',
    other: 'Altro',
    text: 'Testo',
    from: 'Da',
    to: 'A',
    hide: 'Nascondi',
    show: 'Mostra',
    horizontal: 'Orizzontale',
    vertical: 'Verticale',
    addImage: 'Aggiungi immagine',
    confirmDeleteImage: 'Sei sicuro di voler eliminare questa immagine?',
    generating: 'Generazione...',
    indoorClimate: 'Clima interno',
    score: 'Punteggio',
    energyData: 'Dati energetici',
    air: 'Aria',
    liquid: 'Liquido',
    round: 'Rotondo',
    square: 'Quadrato/rettangolare',

    // field labels
    quantity: 'Quantità',
    location: 'Posizione',
    priority: 'Priorità',
    yearInstalled: 'Anno di installazione',
    medium: 'Fluido',

    // section / navigation labels
    inspection: 'Ispezione',
    info: 'Informazioni',
    purpose: 'Scopo',
    module: 'Modulo',
    control: 'Controllo & Regolazione',
    equipment: 'Attrezzature',
    hvacSystems: 'Sistemi HVAC',
    thermalZones: 'Zone termiche',
    zones: 'Zone',
    heatingCooling: 'Riscaldamento & raffreddamento',
    heatingAndCooling: 'Riscaldamento & raffreddamento',
    heatingOnly: 'Solo riscaldamento',
    domesticHotWater: 'Acqua calda sanitaria',
    centralEnergy: 'Energia centrale',
    excessEnergy: 'Energia in eccesso',
    solarPv: 'Fotovoltaico',
    solarThermal: 'Solare termico',
    solarCells: 'Fotovoltaico',
    attachments: 'Allegati',
    annualSimulation: 'Simulazione annuale',
    energyLabel: 'Etichetta energetica',
    actions: 'Azioni',
    lighting: 'Illuminazione',
    report: 'Rapporto',
    hvac: 'HVAC',
    windows: 'Finestre',
    doors: 'Porte',
    gates: 'Cancelli',
    walls: 'Pareti',
    exteriorWalls: 'Pareti esterne',
    floor: 'Pavimento verso il terreno',
    roof: 'Tetto',
    basement: 'Costruzione del seminterrato',
    groundConditions: 'Condizioni del terreno',
    airLeakage: "Perdita d'aria",
    thermalMass: 'Massa termica',
    internalLoads: 'Carichi interni',
    productionEquipment: 'Attrezzature di produzione',
    ground: 'Terreno',
    zone: 'Zona',
    wall: 'Parete',
    window: 'Finestra',
    door: 'Porta',
    gate: 'Cancello',

    // climate
    climate: 'Clima',
    climatized: 'Climatizzato',
    partlyClimatized: 'Parzialmente climatizzato',
    unclimatized: 'Non climatizzato',
    floorHeight: 'Altezza piano (m)',

    // units and physical quantities
    area: 'Area (m²)',
    areaShort: 'Area',
    volume: 'Volume (L)',
    volumeShort: 'Volume',
    length: 'Lunghezza (m)',
    power: 'Potenza (kW)',
    powerShort: 'Potenza',
    uValue: 'Valore U (W/m²K)',
    uValueShort: 'Valore U',
    coverageArea: 'Area di copertura (m²)',
    coverageAreaShort: 'Area di copertura',
    coverageVolume: 'Volume di copertura',
    heatingEffect: 'Potenza di riscaldamento (kW)',
    coolingEffect: 'Potenza di raffreddamento (kW)',
    effect: 'Potenza (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'COP stagionale',
    seasonalEER: 'EER stagionale',
    efficiency: 'Efficienza',
    systemEfficiency: 'Efficienza del sistema (%)',
    co2eEmissionFactor: 'Fattore di emissione CO₂e (g/kWh)',
    temperatureSupply: 'Temperatura di mandata (°C)',
    temperatureReturn: 'Temperatura di ritorno (°C)',
    avgTemp: 'Temp media',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: "Volume d'aria",
    heatRecovery: 'Recupero di calore',
    panelArea: 'Area del pannello',
    cellType: 'Tipo di cella',
    azimuth: 'Azimut',
    value: 'Valore',
    unit: 'Unità',

    // system / fuel
    systemType: 'Tipo di sistema',
    systemTypeShort: 'Tipo di sistema',
    energySource: 'Fonte di energia',
    energySourceShort: 'Fonte di energia',
    specificFuelType: 'Tipo di combustibile',
    selectSpecificFuelType: 'Seleziona combustibile...',
    inverterControlled: 'Controllato da inverter',
    nominalLoad: 'Carico nominale',
    minimumLoad: 'Carico minimo',
    degradeCoeff: 'Coeff. di degradazione',
    heatPump: 'Pompa di calore',
    electric: 'Elettrico',
    oil: 'Gasolio',
    gas: 'Gas',
    rock: 'Roccia',
    coolingOnly: 'Solo raffreddamento',

    // performance / magnitude grades
    high: 'Alto',
    low: 'Basso',
    normal: 'Normale',

    // dimensions
    width: 'Larghezza (m)',
    height: 'Altezza (m)',
    depth: 'Profondità (m)',

    // zone editor
    userDefined: "Definito dall'utente",
    calculator: 'Calcolatore',
    compass: {
      N: 'N',
      NE: 'NE',
      E: 'E',
      SE: 'SE',
      S: 'S',
      SW: 'SO',
      W: 'O',
      NW: 'NO',
    },
    directions: {
      n: 'Nord (0°)',
      ne: 'Nord-est (45°)',
      e: 'Est (90°)',
      se: 'Sud-est (135°)',
      s: 'Sud (180°)',
      sw: 'Sud-ovest (225°)',
      w: 'Ovest (270°)',
      nw: 'Nord-ovest (315°)',
    },
    structuralNodes: 'Nodi strutturali',
    structuralNode: 'Nodo strutturale',
    addStructuralNode: 'Aggiungi nodo strutturale',
    copyStructuralNode: 'Copia nodo strutturale',
    confirmDeleteStructuralNode: 'Eliminare questo nodo strutturale?',
    boundary: 'Condizione al contorno',
    boundaryInteriorAir: 'Aria interna',
    boundaryExterior: 'Esterno',
    boundaryAdjacentZone: 'Zona adiacente',
    boundaryAdiabatic: 'Adiabatico',
    node: 'Nodo',
    addNode: 'Aggiungi nodo',
    copyNode: 'Copia nodo',
    confirmDeleteNode: 'Eliminare questo nodo?',
    surfaceType: 'Tipo di superficie',
    surfaceCeiling: 'Soffitto',
    surfaceArea: 'Superficie (m\u00B2)',
    heatTransferCoeff: 'Coeff. di scambio termico (W/m\u00B2K)',
    totalMass: 'Massa totale (kg/m\u00B3)',
    specificHeatCapacity: 'Capacità termica specifica (J/kgK)',

    // insulation grades
    insulated: 'Isolato',
    uninsulated: 'Non isolato',
    poorlyInsulated: 'Scarsamente isolato',
    normallyInsulated: 'Normalmente isolato',
    wellInsulated: 'Ben isolato',
    veryWellInsulated: 'Molto ben isolato',
    selectInsulation: 'Seleziona isolamento...',
    selectPerformance: 'Seleziona rendimento...',
    selectFuelType: 'Seleziona tipo di combustibile...',

    // UI layout
    basicSettings: 'Impostazioni di base',
    additionalInfo: 'Informazioni aggiuntive',
    showAdvanced: 'Mostra avanzate',
    hideAdvanced: 'Nascondi avanzate',
    advanced: 'Avanzate',

    settingUp: 'Configurazione...',
    co2PerKwh: 'CO₂ per kWh [g]',
    gridFee: 'Tariffa di rete [NOK/kWh]',
    enovaSupport: 'Supporto Enova [%]',
    descriptionPlaceholder:
      "Descrivi l'intervento in dettaglio: cosa viene modificato, perché e il risultato atteso. Includi un calcolo della riduzione stimata del consumo energetico se l'intervento viene attuato, insieme a una valutazione dei costi e delle conseguenze riguardanti umidità e clima interno legati all'intervento.",
    electricityZone: 'Zona elettrica',
    selectZone: 'Seleziona una zona...',
    runSimulation: "Avvia simulazione dell'edificio",
    runningSimulation: 'Simulazione in corso...',
    simulationDescription: 'Esegue simulazione oraria del bilancio energetico',
    baselineProgress: 'Simulazione di riferimento in corso... (1/2)',
    actionProgress: "Simulazione dell'azione in corso... (2/2)",
    baselineStarted: 'Simulazione di riferimento avviata...',
    simulationStarted: "Simulazione dell'azione avviata...",
    noAnnualSimulation:
      'Eseguire prima una simulazione annuale per abilitare il confronto delle azioni.',
    simulationResults: 'Risultati della simulazione',
    lastSimulated: 'Ultima simulazione',
    nettEnergyDemand: 'Fabbisogno energetico netto',
    energyCategory: 'Categoria energetica',
    baselineKwh: 'Riferimento (kWh)',
    actionKwh: 'Azione (kWh)',
    savingsKwh: 'Risparmio (kWh)',
    baselineKwhM2: 'Riferimento (kWh/m²)',
    actionKwhM2: 'Azione (kWh/m²)',
    savingsPercent: 'Risparmio (%)',
    baseline: 'Riferimento',
    afterAction: "Dopo l'azione",
    solarProduction: 'Produzione solare',
    savings: 'Risparmio',
    costSavings: 'Costi e risparmi',
    annualEnergySavings: 'Risparmio energetico annuale',
    kwhYear: 'kWh/anno',
    energySavingsTooltip:
      'Riduzione del fabbisogno energetico totale dai miglioramenti',
    reduction: 'riduzione',
    increase: 'aumento',
    annualCostSavings: 'Risparmio sui costi annuale',
    nokYear: 'NOK/anno',
    costSavingsTooltip:
      'Risparmio totale sui costi dalla riduzione del consumo energetico e dai ricavi della produzione solare esportata',
    netCo2Reduction: 'Riduzione netta di CO₂',
    kgCo2Year: 'kg CO₂/anno',
    co2Tooltip: 'Utilizzando {value} g CO₂/kWh',
    tonnes: 'tonnellate',
    paybackPeriod: 'Periodo di ammortamento',
    paybackTooltip: "Tempo per recuperare l'investimento iniziale",
    years: 'anni',
    investmentLabel: 'Investimento: {value} NOK',
    noInvestmentCost: 'Nessun costo di investimento specificato',
    beforeExisting: 'Prima - Sistema esistente',
    afterNew: 'Dopo - Nuovo sistema',
    investment: 'Investimento',
    installationType: 'Tipo di installazione',
    simple: 'Semplice',
    complex: 'Complesso',
    deliveredEnergy: 'Energia fornita',
    roiTitle: "Ritorno sull'investimento nel tempo",
    roiCumulativeSavings: 'Risparmi cumulativi',
    roiNetValue: 'Valore netto (dopo investimento)',
    roiYears: 'Anni',
    roiBreakEven:
      'Il punto di pareggio si verifica quando il valore netto supera lo zero (anno {value})',

    // misc
    presenceControl: 'Controllo presenza',
    distributionLosses: 'Perdite di distribuzione e accumulo',
    installationCost: 'Costo di installazione [NOK]',
    installationCostShort: 'Costo di installazione',
    noZones:
      'Nessuna zona termica trovata. Aggiungere prima le zone termiche nella sezione Zone termiche.',

    // energy source labels duplicated across heatingCooling,
    // productionEquipment, hvac and centralEnergy
    energySources: {
      electricity: 'Elettricità',
      heatpumpAirToAir: 'Pompa di calore aria-aria',
      fossilOil: 'Olio fossile',
      fossilGas: 'Gas fossile',
      fossilSolidFuel: 'Combustibile solido fossile',
      bioOil: 'Olio bio',
      bioGas: 'Biogas',
      bioSolidFuel: 'Combustibile solido bio',
      districtHeating: 'Teleriscaldamento',
      districtCooling: 'Teleraffrescamento',
      otherSources: 'Altre fonti',
    },

    // schedule block duplicated between thermalZones.schedule and
    // productionEquipment
    schedule: {
      operationalSchedule: 'Programma operativo',
      addSchedule: 'Aggiungi programma',
      clickToToggle: 'Clicca sulle ore per attivare/disattivare',
      avgTemp: 'Temp media',
      days: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
      months: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      hours: 'Ore',
      weekly: 'Settimanale',
      annual: 'Annuale',
      on: 'ON',
      off: 'OFF',
      hoursPerDayUnit: 'h/giorno',
      hoursPerWeekUnit: 'h/settimana',
      hoursPerYearUnit: 'h/anno',
      setpointPerHour: 'Temperatura di setpoint per ora',
      setpointInfoTooltip:
        'Usa ON/OFF per controllare le ore operative. I valori di setpoint per le ore ON sono usati nei calcoli. Le ore OFF sono non operative.',
      copyToWeekdays: 'Copia nei giorni feriali',
      copyToWeekends: 'Copia nel fine settimana',
      resetToStandards: 'Ripristina a',
      confirmDeleteSchedule: 'Eliminare questo programma?',
      fromMonth: 'Da',
      toMonth: 'A',
    },
  },

  // List page labels
  lists: {
    quantity: 'Quantità',
    totalArea: 'Totale (m²)',
    thermalZones: {
      duplicateZone: 'Duplica zona',
      copySuffix: 'copia',
      duplicateSuccess: 'Zona duplicata con successo',
      duplicateError: 'Impossibile duplicare la zona',
    },
    exteriorWalls: {
      addFirst: 'Clicca per aggiungere la tua prima parete esterna',
      addWall: 'Aggiungi parete',
      duplicateWall: 'Duplica parete',
    },
    windows: {
      addFirst: 'Clicca per aggiungere la tua prima finestra',
      addWindow: 'Aggiungi finestra',
    },
    doors: {
      addFirst: 'Clicca per aggiungere la tua prima porta',
      addDoor: 'Aggiungi porta',
    },
    gates: {
      addFirst: 'Clicca per aggiungere il tuo primo cancello',
      addGate: 'Aggiungi cancello',
    },
    productionEquipment: {
      addFirst: 'Clicca per aggiungere la tua prima attrezzatura di produzione',
      addEquipment: 'Aggiungi attrezzatura di produzione',
    },
    hvac: {
      addFirst: 'Clicca per aggiungere la tua prima unità HVAC',
      addHvac: 'Aggiungi HVAC',
    },
    heatingCooling: {
      addFirstHeating:
        'Clicca per aggiungere un sistema di riscaldamento o raffreddamento',
      addHeating: 'Aggiungi sistema',
    },
    domesticHotWater: {
      add: 'Aggiungi acqua calda sanitaria',
      addFirst: 'Clicca per aggiungere acqua calda sanitaria',
    },
    centralEnergy: {
      add: 'Aggiungi modulo energia centrale',
      addFirst: 'Clicca per aggiungere un modulo energia centrale',
    },
    excessEnergy: {
      add: 'Aggiungi modulo energia in eccesso',
      addFirst: 'Clicca per aggiungere un modulo energia in eccesso',
    },
    solarPv: {
      add: 'Aggiungi modulo fotovoltaico',
      addFirst: 'Clicca per aggiungere un modulo fotovoltaico',
    },
    batteries: {
      add: 'Aggiungi batteria',
      addFirst: 'Clicca per aggiungere una batteria',
    },
    attachments: {
      noInspectionFound: 'Nessuna ispezione trovata',
    },
  },

  // Edit page - Form fields
  inspector: 'Ispettore',
  selectBuilding: 'Seleziona edificio',
  selectedBuilding: 'Edificio',
  selectBuildingPlaceholder: 'Seleziona edificio...',
  notes: 'Note',

  // Edit page - Map panel
  advancedComingSoon: 'In sviluppo',
  mapPlaceholder: 'Mappa Sastech',

  // Status options
  statusDraft: 'Bozza',
  statusInReview: 'In revisione',
  statusCompleted: 'Completato',

  // Validation & feedback
  buildingRequired: 'Seleziona un edificio',
  gpsRequired: "L'edificio selezionato deve avere una posizione GPS",
  createSuccess: 'Ispezione creata con successo',
  updateSuccess: 'Ispezione aggiornata con successo',
  saved: 'salvato',
  saveError: "Impossibile salvare l'ispezione",
  loadError: "Impossibile caricare i dati dell'ispezione",

  // Delete dialog
  deleteTitle: 'Elimina ispezione',
  deleteConfirm: 'Sei sicuro di voler eliminare questa ispezione?',
  deleteSuccess: 'Ispezione eliminata con successo',
  deleteError: "Impossibile eliminare l'ispezione",

  // Zone edit
  zoneName: 'Nome della zona',
  zoneCategory: 'Categoria della zona',
  buildingSubcategory: 'Sottocategoria edificio',
  zoneSaved: 'Zona salvata',
  standardElementsUpdated: 'Aggiornati {count} elementi a {tek}',
  braRequired: 'BRA superiore a 0 è richiesto',
  basementAreaRequired:
    'È richiesta una superficie del pavimento del seminterrato maggiore di 0',
  categoryRequired: "Seleziona una categoria dell'edificio",
  yearRequired: "Inserisci l'anno di costruzione",
  floorsRequired: 'Inserisci il numero di piani',
  zoneCategoryRequired: 'Seleziona una categoria di zona',
  subcategoryRequired: "Seleziona una sottocategoria dell'edificio",
  zoneClimateRequired: 'Seleziona un clima di zona',
  floorHeightRequired: "È richiesta un'altezza di piano maggiore di 0",
  airLeakageN50Required:
    "È richiesto un valore di permeabilità all'aria (n50) maggiore di 0",
  thermalBridgePsiRequired:
    'È richiesto un valore di ponte termico normalizzato',
  panelAreaRequired: "È richiesta un'area del pannello maggiore di 0",
  yearInstalledRequired: "L'anno di installazione è obbligatorio",
  soilingLocationRequired:
    'Seleziona una posizione per il fattore di sporcizia',
  cellTypeRequired: 'Seleziona un tipo di cella',
  deleteZone: 'Elimina zona',
  deleteZoneWarning: 'Questa azione non può essere annullata',
  confirmDeleteZone: 'Eliminare questa zona?',
  indoorTemp: 'Temperatura iniziale (°C)',
  zoneClimate: 'Clima della zona',
  thermalBridgeCoeff: 'Struttura portante (ponte termico)',
  thermalBridgePsiValue:
    'Coefficiente di ponte termico normalizzato ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Personalizzato',
    wood: 'Edificio con struttura portante in legno',
    concrete_10cm:
      'Edificio con struttura portante in calcestruzzo, muratura o acciaio e 10 cm di taglio termico nelle facciate',
    concrete_5cm:
      'Edificio con struttura portante in calcestruzzo, muratura o acciaio e 5 cm di taglio termico nelle facciate',
  },
  addZone: 'Aggiungi zona',
  addFirstZone: 'Clicca per aggiungere la tua prima zona',
  image: 'Immagine',
  upload: 'Carica',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Elimina sistema',
    confirmDeleteModule: 'Eliminare questo sistema?',
    deleteHeating: 'Elimina modulo riscaldamento',
    deleteCooling: 'Elimina modulo raffreddamento',
    confirmDeleteHeating: 'Eliminare questo modulo di riscaldamento?',
    confirmDeleteCooling: 'Eliminare questo modulo di raffreddamento?',
    systemType: 'Tipo',
    priorityHelp: '1 = priorità massima (copre la domanda per prima)',
    maxTemperatureSupplied: 'Temperatura massima fornita (°C)',
    systemTypeRequired: 'Seleziona un tipo di sistema',
    energySourceRequired: 'Seleziona una fonte di energia',
    heatingEffectRequired: 'È richiesta una potenza termica maggiore di 0',
    coolingEffectRequired: 'È richiesta una potenza frigorifera maggiore di 0',
    systemEfficiencyRequired:
      'È richiesto un rendimento di sistema maggiore di 0',
    copRequired: 'È richiesto un COP maggiore di 0',
    eerRequired: 'È richiesto un EER maggiore di 0',
  },

  domesticHotWater: {
    deleteDhw: 'Elimina acqua calda sanitaria',
    confirmDelete: 'Eliminare questo modulo di acqua calda sanitaria?',
    heaterType: 'Tipo di riscaldatore',
    volume: 'Volume (L)',
    setpointTemperature: 'Temperatura di setpoint (°C)',
    heatingElementPower: 'Potenza elemento riscaldante (kW)',
    heaterTypes: {
      electric: 'Elettrico',
      centralHeating: 'Riscaldamento centralizzato',
    },
    typeSection: 'Tipo',
    consumptionSection: 'Consumo',
    distributionSection: 'Sistema di distribuzione',
    greyWaterSection: 'Recupero calore acque grigie',
    tapFrequency: 'Frequenza di prelievo',
    tapCyclesPerDay: 'Cicli di prelievo al giorno',
    hasCirculation: 'Sistema acqua calda con circolazione',
    pipeSpecificLength: 'Lunghezza specifica tubazione ACS',
    circulationPipeLength: 'Lunghezza specifica tubazione circolazione',
    greyWaterRecoveryType: 'Tipo di unità di recupero',
    greyWaterEfficiencyGrade: 'Efficienza istantanea',
    greyWaterShareType: 'Quota di acqua calda per il recupero',
    greyWaterConnectionType: 'Variante di collegamento',
    greyWaterPatternType: 'Modello di prelievo',
    greyWaterHelperText:
      "L'energia recuperata dalle acque grigie viene detratta dal fabbisogno energetico totale per il riscaldamento dell'acqua calda sanitaria.",
    tapFrequencyTypes: {
      high: 'Frequenza di prelievo alta',
      normal: 'Frequenza di prelievo normale',
      low: 'Frequenza di prelievo bassa',
      perDay: '/giorno',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Residenziale, percorsi tubi lunghi',
      residentialNormal: 'Residenziale, percorsi tubi normali',
      residentialShort: 'Residenziale, percorsi tubi corti',
      commercialLong: 'Commerciale, percorsi tubi lunghi',
      commercialNormal: 'Commerciale, percorsi tubi normali',
      commercialShort: 'Commerciale, percorsi tubi corti',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Sistema di circolazione, percorsi lunghi',
      circulationNormal: 'Sistema di circolazione, percorsi normali',
      circulationShort: 'Sistema di circolazione, percorsi corti',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Scambiatore di calore a tubo verticale',
      horizontalPipe: 'Scambiatore di calore orizzontale',
      tankRecovery: 'Recupero di calore a serbatoio',
    },
    greyWaterEfficiencyGrades: {
      low: 'Bassa efficienza',
      normal: 'Efficienza normale',
      high: 'Alta efficienza',
    },
    greyWaterShareTypes: {
      allShowers: 'Tutte le docce al recupero',
      halfShowers: '50% delle docce al recupero',
      thirdShowers: '30% delle docce al recupero',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: "Collegato solo al serbatoio dell'acqua calda",
      coldWaterShowerOnly:
        "Collegato solo al circuito dell'acqua fredda doccia",
      hotWaterTankAndColdWaterShower:
        "Collegato al serbatoio dell'acqua calda e al circuito dell'acqua fredda doccia",
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation: 'Residenziale con accumulo acque grigie',
      residentialWithoutAccumulation:
        'Residenziale senza accumulo acque grigie',
      showerWithoutAccumulation: 'Impianto docce senza accumulo acque grigie',
      showerWithAccumulation: 'Impianto docce con accumulo acque grigie',
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: 'Fonti di energia locali',
    centralEnergySources: 'Fonti di energia centrali',
    noCentralModules: 'Nessun modulo energia centrale configurato',
    pipeConfiguration: 'Configurazione tubazioni',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Flusso costante',
    variableFlow: 'Flusso variabile',
    lengthOfPipe: 'Lunghezza tubo (m)',
    percentageInHeatedSpace: '% nello spazio riscaldato',
    avgTempOutsideHeatedSpace: 'Temp. media fuori spazio riscaldato (°C)',
    // Dropdown labels
    waterSystemQuality: 'Qualità del sistema idraulico',
    waterDistributionType: "Tipo di distribuzione dell'acqua",
    pipeInsulationType: 'Isolamento tubazioni',
    // Water system quality options (NS 3031:2025 Table E.1)
    qualityOptions: {
      poor: 'Distribuzione acqua scarsa',
      normal: 'Distribuzione acqua normale',
      good: 'Distribuzione acqua buona',
    },
    // Water distribution system types (NS 3031:2025 Table E.1)
    distributionTypes: {
      radiatorFloorHeating:
        'Sistema di riscaldamento, radiatori/riscaldamento a pavimento',
      heatingBattery:
        'Sistema di riscaldamento, batteria di riscaldamento in ventilazione',
      localCoolingCeilingBaffles:
        'Sistema di raffreddamento, raffreddamento locale/pannelli a soffitto',
      centralCoolingBattery:
        'Sistema di raffreddamento, batteria centrale in ventilazione',
      dhwCirculation: 'Circolazione ACS',
      energyWellBrine: 'Pozzo energetico, salamoia',
    },
    // Pipe insulation types (NS 3031:2025 Table H.2)
    insulationTypes: {
      uninsulated: 'Tubazioni non isolate',
      poorlyInsulated: 'Tubazioni scarsamente isolate',
      normallyInsulated: 'Tubazioni normalmente isolate',
      wellInsulated: 'Tubazioni ben isolate',
      veryWellInsulated: 'Tubazioni molto ben isolate',
    },
    // Distribution pipe length type (NS 3031:2025 Table H.1)
    distributionPipeLengthType: 'Lunghezza tubo per BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong: 'Riscaldamento locale e centrale, tratti lunghi',
      localAndCentralNormal: 'Riscaldamento locale e centrale, tratti normali',
      centralOnlyLong: 'Solo riscaldamento centrale, tratti lunghi',
      centralOnlyShort: 'Solo riscaldamento centrale, tratti corti',
    },
    temperatureCannotBeZero: 'La temperatura non può essere 0',
    pipeTemperatureZeroWarning:
      'La temperatura di mandata e/o ritorno è impostata su 0.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: 'Elimina attrezzatura di produzione',
    confirmDelete: 'Eliminare questa attrezzatura di produzione?',
    eligibleForHarvesting: 'Idoneo per il recupero energetico',
    eligibleForHarvestingHelp:
      'Contrassegna questa attrezzatura come idonea per il recupero di energia in eccesso',
  },

  // Central Energy Module
  centralEnergy: {
    // Basic settings
    mode: 'Modalità',
    heatPumpTypeRequired:
      'Ogni pompa di calore richiede un tipo di pompa di calore',
    heatPumpNominalLoadRequired:
      'Ogni pompa di calore richiede un carico nominale maggiore di 0',
    heatPumpMinimumLoadRequired:
      'Ogni pompa di calore richiede un carico minimo maggiore di 0',
    combustionBoilerTypeRequired:
      'Ogni caldaia a combustione richiede un tipo di caldaia',
    combustionBoilerFuelSourceRequired:
      'Ogni caldaia a combustione richiede una fonte di combustibile',
    fillRequiredFields: 'Compila tutti i campi obbligatori',
    requiredFieldsNotSaved:
      'Le modifiche non vengono salvate finché tutti i campi obbligatori non sono compilati',
    solarThermalSolarTypeRequired:
      'Ogni fonte solare termica richiede un tipo di collettore',
    solarThermalCollectorAreaRequired:
      'Ogni fonte solare termica richiede una superficie di collettore maggiore di 0',
    otherSourceMaxCapacityRequired:
      'Ogni altra fonte richiede una capacità massima maggiore di 0',
    otherSourceEfficiencyRequired:
      'Ogni altra fonte richiede un rendimento maggiore di 0',
    heatingAndHotWater: 'Riscaldamento e acqua calda',
    thermalZone: 'Zona termica',
    thermalZoneHelp: 'Collegare alla zona termica per la temperatura ambiente',
    noZone: 'Nessuna (autonomo)',
    selectZone: 'Seleziona zona...',
    ambientTemperature: 'Temperatura ambiente',
    ambientTempHelp:
      'Temperatura intorno al modulo quando non collegato a una zona',
    moduleName: 'Modulo energia centrale',
    deleteModule: 'Elimina modulo energia centrale',
    confirmDelete:
      'Eliminare questo modulo energia centrale e tutte le fonti di energia?',
    notLinkedWarning:
      'Questo modulo non è collegato a nessuna apparecchiatura. Aggiungilo come fonte di energia nel riscaldamento/raffrescamento, ventilazione, acqua calda sanitaria o attrezzatura di produzione.',
    notLinkedListWarning:
      '{name} non è collegato a nessuna apparecchiatura. Aggiungilo come fonte di energia per utilizzarlo.',
    notesAttachments: 'Note e allegati',
    energySources: 'Fonti di energia',
    tanks: 'Serbatoi',
    performance: 'Rendimento',
    selectPerformance: 'Seleziona rendimento...',

    // Accumulation tanks
    accumulationTanks: 'Serbatoi di accumulo',
    addTank: 'Aggiungi serbatoio',
    confirmDeleteTank: 'Eliminare questo serbatoio di accumulo?',
    noTanks:
      'Nessun serbatoio di accumulo configurato. Clicca per aggiungerne uno.',
    dhwTank: 'ACS (acqua calda sanitaria)',
    heatingTank: 'Accumulo riscaldamento',
    coolingTank: 'Accumulo raffreddamento',
    insulation: 'Isolamento',
    setpoint: 'Setpoint (°C)',
    maxTemp: 'Temp max (°C)',
    minTemp: 'Temp min (°C)',
    heatLoss: 'Perdita di calore (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: 'Grado di isolamento caldaia',
    boilerInsulationVeryLow: 'Molto poco isolata',
    selectBoilerInsulation: 'Seleziona isolamento...',

    // Energy source configuration
    energySourceConfig: 'Configurazione fonte di energia',
    sourceType: 'Tipo di fonte di energia',
    selectType: 'Seleziona tipo di fonte di energia...',
    sourceName: 'Nome fonte di energia',
    usage: 'Utilizzo',
    dhw: 'ACS',
    addToList: 'Aggiungi alla lista',

    // Priority list
    priorityList: 'Lista di priorità',
    dragToReorder: 'Clicca per modificare. Trascina per riordinare',
    clickToEdit: 'Clicca su una fonte per modificare',
    confirmDeleteSource: 'Eliminare questa fonte di energia?',
    noPrioritySources: 'Nessuna fonte di energia aggiunta',
    noSources:
      'Nessuna fonte di energia aggiunta. Usa il modulo sopra per aggiungere fonti.',

    // Energy source types
    districtHeating: 'Teleriscaldamento',
    combustionBoiler: 'Caldaia a combustione',
    electricBoiler: 'Caldaia elettrica',
    otherSource: 'Altra fonte',

    // Heat pump fields
    heatPumpType: 'Tipo di pompa di calore',
    airToAir: 'Aria-aria',
    airToWater: 'Aria-acqua',
    liquidToWater: 'Acqua-acqua',
    heatingCapacity: 'Capacità di riscaldamento (kW)',
    liquidSource: 'Fonte liquida',
    selectSource: 'Seleziona fonte...',
    freshWater: 'Acqua dolce',
    seaWater: 'Acqua di mare',
    sourceTemp: 'Temp. sorgente (°C)',
    avgYearlyTemp: 'Temp. media annua (°C)',
    maxTemperatureSupplied: 'Temperatura massima fornita (°C)',
    SourceTempeAmplitude: 'Variazione di temperatura della sorgente (°C)',
    energyWellDimensioning: 'Uso e dimensionamento del pozzo geotermico',
    energyWellHeatingOnlyUndersized:
      'Solo riscaldamento (estrazione di calore), pozzo geotermico leggermente sottodimensionato',
    energyWellHeatingOnlyGood:
      'Solo riscaldamento (estrazione di calore), pozzo geotermico ben dimensionato',
    energyWellSomeCoolingUndersized:
      "Riscaldamento e un po' di raffrescamento, pozzo geotermico leggermente sottodimensionato",
    energyWellSomeCoolingGood:
      "Riscaldamento e un po' di raffrescamento, pozzo geotermico ben dimensionato",
    energyWellBalancedUndersized:
      'Riscaldamento e raffrescamento bilanciati, pozzo geotermico leggermente sottodimensionato',
    energyWellBalancedGood:
      'Riscaldamento e raffrescamento bilanciati, pozzo geotermico ben dimensionato',
    highestSourceTemperature:
      'Temperatura della sorgente più alta fornita (°C)',
    waterSourceDepth: 'Profondità di prelievo del calore in mare/acqua',
    CO2EmissionFactor: 'Fattore di emissione CO₂ (g/kWh)',

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Capacità max (kW)',
    energyPrice: 'Prezzo energia (per kWh)',
    temperatureFromSource: 'Temperatura dalla sorgente (°C)',
    // Combustion boiler fields
    boilerType: 'Tipo di caldaia',
    biomass: 'Biomassa',
    fuelSource: 'Fonte di combustibile',
    otherFuelSource: 'Altro',
    fuelType: 'Tipo di combustibile',
    flueGasCondensation: 'Condensazione fumi',
    fuelConfig: 'Configurazione combustibile',
    fuelEnergyContent: 'Contenuto energetico (kWh/L)',
    efficiencyLowLoad: 'Effetto al 30% di carico (kW)',
    effectFullLoad: 'Effetto a pieno carico (kW)',
    isCondensing: 'Caldaia a condensazione',
    operatingSchedule: 'Programma operativo',
    startDate: 'Inizio (giorno/mese)',
    endDate: 'Fine (giorno/mese)',
    startOfDay: 'Ora di inizio',
    endOfDay: 'Ora di fine',
    seasonalMeanTemp: 'Temperatura media stagionale (°C)',

    // Solar thermal fields
    solarType: 'Tipo solare',
    vacuumTube: 'Tubo sottovuoto',
    flatPlate: 'Pannello piano',
    tilt: 'Inclinazione (°)',
    area: 'Area totale (m²)',
    collectorArea: 'Area collettore (m²)',
    pipeLength: 'Lunghezza tubo (m)',
    pipeUValue: 'Valore U tubo (W/mK)',
    collectorSpecs: 'Specifiche collettore',
    efficiencyNormal: 'Efficienza η₀',
    heatLossLinear: 'Perdita di calore a₁ (W/m²K)',
    heatLossSecond: 'Perdita di calore a₂ (W/m²K²)',
    opticalEfficiency: 'Efficienza ottica',
    heatLossCoeff: 'Coefficiente di perdita di calore',
    shadingWinter: 'Fattore ombreggiamento inverno',
    shadingSummer: 'Fattore ombreggiamento estate',
    adjustmentFactor: 'Fattore di correzione',
    tankSpiralPlacementFactor:
      'Fattore di posizionamento della serpentina del serbatoio',
    temperatureColdWater: "Temperatura dell'acqua fredda (°C)",
    temperatureInCollectionTank: 'Temperatura del serbatoio di accumulo (°C)',
    percentageOfCollectorLoopOutside:
      "Percentuale del circuito del collettore all'esterno (%)",
    snowCoverageMonths: 'Mesi con copertura nevosa',
    selectMonths: 'Seleziona mesi...',
    insulationFactorForCollectionLoop:
      'Fattore di isolamento del circuito del collettore',
    selectInsulationFactorForCollectionLoop:
      'Seleziona fattore di isolamento...',

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: 'Isolamento scambiatore di calore',
    selectHeatExchangerInsulation: 'Seleziona isolamento...',
    outletTemperatureRange: 'Intervallo temperatura di uscita',
    selectOutletTempRange: 'Seleziona intervallo...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Perdita scambiatore di calore',
    bdhValue: 'Coefficiente di perdita',
    supplyTemperatureRange: 'Intervallo temperatura di mandata',
    selectSupplyTempRange: 'Seleziona intervallo...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Perdita di distribuzione',
    ddhValue: 'Coefficiente di perdita',
    coolingHeatExchangerInsulation: 'Isolamento scambiatore di raffreddamento',
    selectCoolingHxInsulation: 'Seleziona isolamento...',
    coolingHeatExchangerUValue: 'Scambiatore di raffreddamento',
    coolingHxUValue: 'Valore U (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Cogenerazione (CHP)',
    chpSettings: 'Impostazioni CHP',
    chpFuelType: 'Tipo combustibile CHP',
    selectChpFuelType: 'Seleziona tipo combustibile...',
    chpSolidFuel: 'Combustibile solido',
    chpLiquidFuel: 'Combustibile liquido',
    chpGas: 'Gas',
    chpPerformanceLevel: 'Livello di prestazione',
    selectChpPerformance: 'Seleziona prestazione...',
    chpThermalEfficiency: 'Rendimento termico (%)',
    chpElectricalEfficiency: 'Rendimento elettrico (%)',
    chpTotalEfficiency: 'Rendimento totale (%)',
    chpBoilerType: 'Tipo caldaia CHP',
    selectChpBoilerType: 'Seleziona tipo caldaia...',
    chpBiopellets: 'Bio-pellet',
    chpWoodChips: 'Cippato',
    gasOrOilBoiler: 'Caldaia a gas o olio',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: 'Tipo isolamento tubi',
    selectPipeInsulation: 'Seleziona isolamento...',
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: 'Idoneo per il recupero energetico',
    eligibleForHarvestingHelp:
      'Contrassegna questo modulo come idoneo per il recupero di energia in eccesso',

    // Duct dimensions
    ductDimensions: 'Dimensioni condotto',
    ductShape: 'Forma del condotto',
    diameter: 'Diametro (mm)',
    width: 'Larghezza (mm)',
    height: 'Altezza (mm)',
    airspeed: "Velocità dell'aria (m/s)",

    // Flow properties
    flowProperties: 'Proprietà di flusso',
    temperature: 'Temperatura di estrazione (C)',
    volumeFlow: 'Portata volumetrica',
    volumeFlowAir: 'Portata volumetrica (m³/h)',
    volumeFlowLiquid: 'Portata volumetrica (L/h)',

    // Delete
    deleteModule: 'Elimina modulo energia in eccesso',
    confirmDelete: 'Eliminare questo modulo energia in eccesso?',
    noModuleFound: 'Nessun modulo energia in eccesso trovato',
  },

  // Solar PV Module
  solarPv: {
    // Section headers
    soilingFactors: 'Fattori di sporcamento (\u03C6_soil)',
    panelProperties: 'Proprietà del pannello',
    lossesCoefficients: 'Perdite e coefficienti',
    // Panel angle
    panelAngle: 'Angolo del pannello',
    tiltRange: 'Intervallo di inclinazione: {range}\u00B0',
    angleOutOfRange: 'Angolo fuori intervallo',
    // Soiling
    selectLocation: 'Seleziona posizione...',
    usingStandardTable:
      'Utilizzo della tabella {standard} per intervallo di inclinazione {range}\u00B0',
    // Panel properties
    selectCellType: 'Seleziona tipo di cella...',
    nominalEfficiency: 'Efficienza nominale (0-1)',
    panelAzimuth: 'Azimut del pannello (0-360\u00B0)',
    shadingFactor: 'Fattore di ombreggiamento (0-1)',
    // Losses & coefficients
    mountingType: 'Tipo di montaggio',
    selectMountingType: 'Seleziona tipo di montaggio...',
    windExposure: 'Esposizione al vento',
    selectWindExposure: 'Seleziona esposizione al vento...',
    heatLossFactor: 'Fattore di perdita termica (W/m\u00B2K)',
    inverterEfficiency: "Efficienza dell'inverter (0-1)",
    degradationLoss: 'Perdita di degradazione (0-1)',
    inverterLoss: "Perdita dell'inverter (0-1)",
    transmissionProduct: 'Prodotto di trasmissione (0-1)',
    temperatureCoefficient: 'Coefficiente di temperatura (%/°C)',
    incidentAngleModifier: "Modificatore dell'angolo di incidenza (0-1)",
    // Delete
    deleteModule: 'Elimina modulo fotovoltaico',
    confirmDelete: 'Eliminare questo modulo fotovoltaico?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      "Le batterie sono attualmente incluse solo nelle simulazioni annuali. Non sono ancora incluse nel calcolo dell'etichetta energetica.",
    maxCapacity: 'Capacità massima (kWh)',
    maxChargePower: 'Potenza massima di carica (kW)',
    maxDischargePower: 'Potenza massima di scarica (kW)',
    chargeEfficiency: 'Efficienza di carica (0-1)',
    dischargeEfficiency: 'Efficienza di scarica (0-1)',
    minStateOfCharge: 'Stato di carica minimo (0-1)',
    maxStateOfCharge: 'Stato di carica massimo (0-1)',
    peakShavingThreshold: 'Soglia di riduzione dei picchi (kW)',
    preChargeStateOfCharge: 'Stato di carica di precarica (0-1)',
    maxCapacityRequired: 'È richiesta una capacità massima maggiore di 0',
    maxChargePowerRequired:
      'È richiesta una potenza di carica massima maggiore di 0',
    maxDischargePowerRequired:
      'È richiesta una potenza di scarica massima maggiore di 0',
    deleteBattery: 'Elimina batteria',
    confirmDelete: 'Eliminare questa batteria?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Bilanciato',
    exhaust: 'Estrazione',
    supply: 'Immissione',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: 'Elimina unità HVAC',
    confirmDelete: 'Eliminare questa unità HVAC?',
    // List columns
    heatRecoveryShort: 'Recupero calore',
    airVolumeShort: "Volume d'aria",
    // DX Systems
    addDxSystem: 'Aggiungi sistema DX',
    confirmDeleteDxSystem: 'Eliminare questo sistema DX?',
    // Heating batteries
    addHeatingBattery: 'Aggiungi batteria di riscaldamento',
    confirmDeleteHeatingBattery: 'Eliminare questa batteria di riscaldamento?',
    // Cooling batteries
    addCoolingBattery: 'Aggiungi batteria di raffreddamento',
    confirmDeleteCoolingBattery: 'Eliminare questa batteria di raffreddamento?',

    // Section headers
    namePlaceholder: "Nome dell'unità di ventilazione",
    dxSystemNamePlaceholder: 'Nome del sistema DX',
    batteryNamePlaceholder: 'Nome della batteria',
    flowSfpSettings: 'Portata e impostazioni SFP',
    temperatureMeasurements: 'Misurazioni di temperatura',
    dxSystems: 'DX (Espansione diretta)',
    heatingBatteries: 'Batterie di riscaldamento',
    coolingBatteries: 'Batterie di raffreddamento',
    naturalVentilation: 'Ventilazione naturale',

    // SFP fields
    sfpCalculationMethod: 'Metodo di calcolo SFP',
    sfpAsFunction: 'Potenza specifica del ventilatore',
    yearBands: {
      pre1985: 'Prima del 1985',
      '1985to1995': '1985 - 1995',
      '1995to2005': '1995 - 2005',
      '2005to2013': '2005 - 2013',
      '2013to2020': '2013 - 2020',
      from2020: '2020 e successivi',
    },
    suggestions: {
      yearHelp:
        "L'anno di installazione dell'unità di ventilazione. Determina il tipo di motore, l'SFP e il recupero di calore tipici del periodo.",
      hintLabel: 'Suggerimento',
      calculatedLabel: 'Calcolato',
      apply: 'Usa',
      applyAll: 'Usa ({count}) suggerimenti',
      noSuggestions: 'Nessun suggerimento',
      applyAllHelp: 'Applica tutti i valori suggeriti in questa pagina.',
    },

    // Flow fields
    fanPower: 'Potenza ventilatore',
    coverage: 'Copertura',
    fanPowerIn: 'Potenza ventilatore ingresso (kW)',
    fanPowerOut: 'Potenza ventilatore uscita (kW)',
    // Supply air volume
    supplyAirVolume: 'Volume aria di mandata',
    airVolumeOperating: 'Funzionamento (m³/h)',
    airVolumeCapacity: 'Capacità (m³/h)',
    airVolumeNonOperating: 'Fuori servizio (m³/h)',
    // Extraction air volume
    extractionAirVolume: 'Volume aria di estrazione',
    airVolumeExtractionOperating: 'Funzionamento (m³/h)',
    airVolumeExtractionCapacity: 'Capacità (m³/h)',
    airVolumeExtractionNonOperating: 'Fuori servizio (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Tipo di recupero calore',
    efficiencyHR: 'Efficienza RC (%)',
    frostProtection: 'Protezione antigelo',
    frostProtectionTemperature: 'Temperatura protezione antigelo (°C)',

    // Temperature
    measuredSupplyTemp: 'Temp. mandata misurata (°C)',
    measuredExhaustTemp: 'Temp. estrazione misurata (°C)',

    // DX System
    dxSystem: 'Sistema DX',
    dxType: 'Tipo',

    // Battery fields
    heatingBattery: 'Batteria di riscaldamento',
    coolingBattery: 'Batteria di raffreddamento',
    batteryType: 'Tipo',

    // Priority lists
    heatingPriorityList: 'Priorità di riscaldamento',
    coolingPriorityList: 'Priorità di raffreddamento',
    priorityListHelp: 'Trascina per riordinare la priorità per i calcoli',
    noPriorityItems: 'Nessun elemento configurato',

    // zone linking
    linkedZones: 'Zone collegate',
    noLinkedZones: 'Nessuna zona collegata',
    manageZones: 'Gestisci zone',
    useZoneMap: 'Usa mappa delle zone',
    linkZonesTitle: 'Collega zone termiche',
    noZonesAvailable: 'Nessuna zona termica disponibile',
    zonesLinked: 'Zone collegate con successo',
    noZoneWarning: 'Questa unità HVAC non è collegata a una zona termica.',
    noZoneListWarning: '{name} non è collegato a una zona termica.',
    sfp100Required: 'È richiesto un SFP @ 100% maggiore di 0',
    airVolumeOperatingRequired:
      "È richiesta una portata d'aria di mandata in funzionamento maggiore di 0",
    airVolumeCapacityRequired:
      "È richiesta una capacità d'aria di mandata maggiore di 0",
    airVolumeExtractionOperatingRequired:
      "È richiesta una portata d'aria di estrazione in funzionamento maggiore di 0",
    dxEnergySourceRequired: 'Ogni sistema DX richiede una fonte di energia',
    dxSystemEfficiencyRequired:
      'Ogni sistema DX richiede un rendimento di sistema maggiore di 0',
    heatingBatteryPowerRequired:
      'Ogni batteria di riscaldamento richiede una potenza maggiore di 0',
    heatingBatterySystemEfficiencyRequired:
      'Ogni batteria di riscaldamento richiede un rendimento di sistema maggiore di 0',
    heatingBatteryEnergySourceRequired:
      'Ogni batteria di riscaldamento richiede una fonte di energia',
    coolingBatteryPowerRequired:
      'Ogni batteria di raffreddamento richiede una potenza maggiore di 0',
    coolingBatterySystemEfficiencyRequired:
      'Ogni batteria di raffreddamento richiede un rendimento di sistema maggiore di 0',
    coolingBatteryEnergySourceRequired:
      'Ogni batteria di raffreddamento richiede una fonte di energia',

    supplementaryFactor: 'Fattore supplementare',

    // Motor type dropdown options
    motorType: 'Tipo di motore',
    motorTypes: {
      none: 'Nessuno',
      belt: 'Trasmissione a cinghia',
      axial: 'Ventilatore assiale',
      EC: 'Motore EC',
      AC: 'Motore AC',
      DC: 'Motore DC',
      VSD: 'Inverter (VSD)',
      other: 'Altro',
    },

    // DX type dropdown options
    dxTypes: {
      cooling: 'Solo raffreddamento',
      heating: 'Solo riscaldamento',
      both: 'Riscaldamento e raffreddamento',
    },

    // Flow type radio options
    flowTypes: {
      variable: 'Portata variabile',
      constant: 'CAV, portata costante',
      optimal: 'DCV, a domanda',
    },

    // Battery types
    batteryTypes: {
      water: 'Acqua',
      electric: 'Elettrico',
      heatPump: 'Pompa di calore',
      other: 'Altro',
    },

    // Heat recovery types (keys match NS 3031:2025 Table B.6)
    heatRecoveryTypes: {
      rotaryWheel: 'Scambiatore rotativo',
      crossFlow: 'Scambiatore a piastre a flussi incrociati',
      plateCounterflow: 'Scambiatore a piastre controcorrente',
      runAroundCoil: 'Sistema a circuito chiuso',
      heatPipe: 'Tubo di calore',
      none: 'Nessuno',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Nome parete',
    direction: 'Direzione',
    type: 'Tipo di parete',
    shadingFactor: 'Fattore di ombreggiamento',
    deleteWall: 'Elimina parete',
    confirmDelete: 'Eliminare questa parete?',
    directionRequired: 'Seleziona una direzione della parete',
    areaRequired: "È richiesta un'area di parete maggiore di 0",
    uValueRequired: 'È richiesto un valore U maggiore di 0',
    windowsExceedArea:
      'La superficie totale delle finestre supera la superficie del muro.',
    doorsExceedArea:
      'La superficie totale delle porte supera la superficie del muro.',
    gatesExceedArea:
      'La superficie totale dei cancelli supera la superficie del muro.',
    combinedExceedArea:
      'La superficie combinata di finestre, porte e cancelli supera la superficie del muro.',
    windowsExceedAreaList:
      '{name}: la superficie totale delle finestre supera la superficie del muro.',
    doorsExceedAreaList:
      '{name}: la superficie totale delle porte supera la superficie del muro.',
    gatesExceedAreaList:
      '{name}: la superficie totale dei cancelli supera la superficie del muro.',
    combinedExceedAreaList:
      '{name}: la superficie combinata di finestre, porte e cancelli supera la superficie del muro.',
    options: {
      custom: 'Personalizzato',
      standard: 'Standard',
      timberFrame36_150: 'Telaio legno 36mm, 150mm isolamento',
      timberFrame36_200: 'Telaio legno 36mm, 200mm isolamento',
      timberFrame36_250: 'Telaio legno 36mm, 250mm isolamento',
      timberFrame48_150: 'Telaio legno 48mm, 150mm isolamento',
      timberFrame48_200: 'Telaio legno 48mm, 200mm isolamento',
      timberFrame48_250: 'Telaio legno 48mm, 250mm isolamento',
      epsBlock310: 'Blocco EPS 310mm (nucleo calcestruzzo 140mm)',
      epsBlock370: 'Blocco EPS 370mm (nucleo calcestruzzo 140mm)',
      epsBlock430: 'Blocco EPS 430mm (nucleo calcestruzzo 140mm)',
      iProfile200: 'Profilo I acciaio, 200mm isolamento',
      iProfile300: 'Profilo I acciaio, 300mm isolamento',
      iProfile400: 'Profilo I acciaio, 400mm isolamento',
      lwaBlock250: 'Blocco aggregati leggeri (Isoblokk) 250mm',
      lwaBlock300: 'Blocco aggregati leggeri (Isoblokk) 300mm',
      lwaBlock350: 'Blocco aggregati leggeri (Isoblokk) 350mm',
      slottedSteel200: 'Acciaio forato, 200mm isolamento',
      slottedSteel250: 'Acciaio forato, 250mm isolamento',
      slottedSteel300: 'Acciaio forato, 300mm isolamento',
      unslottedSteel200: 'Acciaio non forato, 200mm isolamento',
      unslottedSteel250: 'Acciaio non forato, 250mm isolamento',
      unslottedSteel300: 'Acciaio non forato, 300mm isolamento',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Piccola casa',
      apartmentBlock: 'Condominio',
      kindergarten: 'Asilo',
      officeBuilding: 'Ufficio',
      schoolBuilding: 'Scuola',
      universityCollege: 'Università/College',
      hospital: 'Ospedale',
      nursingHome: 'Casa di cura',
      hotelBuilding: 'Hotel',
      sportsBuilding: 'Sport',
      commercialBuilding: 'Commerciale',
      culturalBuilding: 'Cultura',
      lightIndustry: 'Industria leggera/Magazzino',
    },
    description: {
      smallHouse:
        'Casa unifamiliare, bifamiliare, a schiera o altro piccolo edificio residenziale.',
      apartmentBlock: 'Blocco residenziale con due o più piani.',
      kindergarten:
        "Edificio destinato all'asilo nido o all'educazione della prima infanzia.",
      officeBuilding:
        'Uffici semplici, uffici climatizzati o edifici per esposizioni/congressi.',
      schoolBuilding:
        'Locali didattici, comprese scuole con piscina o palestra.',
      universityCollege:
        'Edifici universitari, laboratori o strutture di ricerca.',
      hospital: 'Ospedali, hotel ospedalieri o edifici di laboratorio medico.',
      nursingHome: 'Case di cura per assistenza a lungo termine.',
      hotelBuilding: 'Hotel, ristoranti o altri edifici per alloggio.',
      sportsBuilding:
        'Palestre, piscine e altre strutture sportive con spogliatoi.',
      commercialBuilding:
        'Negozi, esercizi con celle frigorifere o stazioni di servizio.',
      culturalBuilding: 'Cinema, musei, biblioteche ed edifici religiosi.',
      lightIndustry:
        'Edifici industriali, magazzini, edifici agricoli o altri laboratori.',
    },
  },

  buildingSubcategories: {
    1: 'Casa unifamiliare',
    2: 'Casa unifamiliare con unità in affitto',
    3: 'Bifamiliare (orizzontale)',
    4: 'Bifamiliare (verticale)',
    5: 'Casa a quattro unità',
    6: 'Casa a catena',
    7: 'Casa a schiera',
    8: 'Casa vacanze',
    9: 'Altra piccola casa',
    10: 'Appartamento',
    11: 'Altro residenziale',
    12: 'Edificio per asilo nido',
    13: 'Uffici semplici',
    14: 'Uffici con ventilazione e raffrescamento',
    15: 'Edificio fieristico/congressuale',
    16: 'Altro edificio per uffici',
    17: 'Locali didattici',
    18: 'Scuola con piscina',
    19: 'Scuola con palestra',
    20: 'Edificio scolastico',
    21: 'Edificio laboratorio',
    22: 'Altro edificio di ricerca',
    23: 'Ospedale',
    24: 'Hotel ospedaliero',
    25: 'Laboratorio ospedaliero',
    26: 'Casa di cura',
    27: 'Edificio alberghiero',
    28: 'Edificio per alloggio',
    29: 'Edificio ristorante',
    30: 'Altro edificio alberghiero',
    31: 'Palestra',
    32: 'Palestra con docce',
    33: 'Palestra con piscina',
    34: 'Negozio',
    35: 'Negozio con cella frigorifera',
    36: 'Stazione di servizio',
    37: 'Edificio culturale',
    38: 'Cinema',
    39: 'Museo/biblioteca',
    40: 'Edificio per attività religiose',
    41: 'Edificio industriale',
    42: 'Edificio per approvvigionamento energetico',
    43: 'Magazzino',
    44: 'Edificio per pesca/agricoltura',
    45: 'Altra industria',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Programma di riscaldamento',
      coolingSchedule: 'Programma di raffreddamento',
      addHeatingSchedule: 'Aggiungi programma di riscaldamento',
      addCoolingSchedule: 'Aggiungi programma di raffreddamento',
    },
    yearPeriods: {
      TEK50: 'Prima del 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: 'Dal 2017 in poi',
    },
    hasFloorToGround: 'La zona ha un pavimento verso il terreno',
    hasRoof: 'La zona ha un tetto',
    isBasement: 'La zona è un seminterrato',
    floor: {
      type: 'Tipo di pavimento verso il terreno',
      area: 'Pavimento verso il terreno (m²)',
      options: {
        custom: 'Personalizzato',
        standard: 'Standard',
        tiles: 'Piastrelle su calcestruzzo',
        parquetChipBoard: 'Parquet su truciolato',
        carpetConcrete: 'Moquette su calcestruzzo',
      },
    },
    roof: {
      type: 'Tipo di tetto',
      optionsTitle: 'Costruzione del tetto',
      angle: 'Angolo del tetto',
      hasWindows: 'Il tetto ha finestre',
      areaRequired: 'È richiesta una superficie del tetto maggiore di 0',
      windowArea: 'Superficie finestre (m²)',
      glassType: 'Tipo di vetro',
      pitchTypes: {
        flat: 'Tetto piano',
        lowSlope: 'Pendenza bassa',
        gentlePitch: 'Pendenza leggera',
        standardPitch: 'Pendenza standard',
        steepPitch: 'Pendenza ripida',
        verySteepPitch: 'Pendenza molto ripida',
      },
      options: {
        custom: 'Personalizzato',
        standard: 'Standard',
        compactConcrete200: 'Tetto piano, calcestruzzo, 200mm isolamento',
        compactConcrete300: 'Tetto piano, calcestruzzo, 300mm isolamento',
        compactConcrete400: 'Tetto piano, calcestruzzo, 400mm isolamento',
        compactSteel200: 'Tetto piano, acciaio, 200mm isolamento',
        compactSteel300: 'Tetto piano, acciaio, 300mm isolamento',
        compactSteel400: 'Tetto piano, acciaio, 400mm isolamento',
        pitched48mm200: 'Tetto a falde, travetti 48mm, 200mm isolamento',
        pitched48mm300: 'Tetto a falde, travetti 48mm, 300mm isolamento',
        pitched48mm400: 'Tetto a falde, travetti 48mm, 400mm isolamento',
        pitchedIBeam200: 'Tetto a falde, travi ad I, 200mm isolamento',
        pitchedIBeam300: 'Tetto a falde, travi ad I, 300mm isolamento',
        pitchedIBeam450: 'Tetto a falde, travi ad I, 450mm isolamento',
        coldAttic200: 'Sottotetto freddo, 200mm isolamento',
        coldAttic300: 'Sottotetto freddo, 300mm isolamento',
        coldAttic450: 'Sottotetto freddo, 450mm isolamento',
      },
    },
    basement: {
      dimensions: 'Dimensioni',
      area: 'Superficie del pavimento contro terra (m²)',
      wallPerimeter: 'Perimetro di parete interrata (m)',
      fillHeight: 'Profondità sotto il terreno (m)',
      wallThickness: 'Spessore muro (m)',
      wallConstruction: 'Parete del seminterrato',
      wallConstructionType: 'Tipo di parete',
      wallUValue: 'Valore U parete (W/m²K)',
      floorConstruction: 'Pavimento del seminterrato',
      floorConstructionType: 'Tipo di pavimento',
      floorUValue: 'Valore U pavimento (W/m²K)',
      intro:
        'Ricorda di ridurre il pavimento su terreno della zona sovrastante della superficie del seminterrato.',
      floorConstructionOptions: {
        none: 'Nessuno',
        standard: 'Standard',
        concrete100: 'Calcestruzzo su terra con 100mm isolamento',
        concrete150: 'Calcestruzzo su terra con 150mm isolamento',
        concrete200: 'Calcestruzzo su terra con 200mm isolamento',
        concrete250: 'Calcestruzzo su terra con 250mm isolamento',
        concrete300: 'Calcestruzzo su terra con 300mm isolamento',
        concrete350: 'Calcestruzzo su terra con 350mm isolamento',
        concrete400: 'Calcestruzzo su terra con 400mm isolamento',
        wood200: 'Travetti in legno con 200mm isolamento',
        wood250: 'Travetti in legno con 250mm isolamento',
        wood300: 'Travetti in legno con 300mm isolamento',
      },
    },
    groundConditions: {
      type: 'Tipo di terreno',
      thermalConductivity: 'Conducibilità termica λ (W/(m·K))',
      heatCapacity: 'Capacità termica Cv (Wh/(m³·K))',
      penetrationDepth: 'Profondità di penetrazione periodica δ (m)',
      options: {
        clay: 'Argilla/limo',
        sand: 'Sabbia/ghiaia',
        rock: 'Roccia',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Capacità termica della zona',
      heatCapacityCategory: 'Categoria capacità termica',
      normalizedHeatCapacity: 'Capacità termica normalizzata (Wh/m²K)',
      interiorWalls: 'Pareti interne',
      cladding: 'Rivestimento',
      heatCapacity: 'Capacità termica (Wh/m²K)',
      furniture: 'Mobili',
      furnitureGrade: 'Grado mobili',
      massFactor: 'Fattore di massa (Wh/m²K)',
      heatCapacityCategoryRequired:
        'Seleziona una categoria di capacità termica',
      claddingRequired: 'Seleziona un tipo di rivestimento',
      furnitureGradeRequired: 'Seleziona un grado di mobilio',
      labelFirstOption: 'Zona molto leggera',
      labelSecondOption: 'Zona leggera',
      labelThirdOption: 'Zona mediamente pesante',
      labelFourthOption: 'Zona pesante',
      labelFifthOption: 'Zona molto pesante',
      shortDescriptionFirstOption:
        'Solaio leggero, rivestimento sottile, pareti leggere',
      shortDescriptionSecondOption:
        'Soffitto acustico, moquette su cemento, pareti leggere',
      shortDescriptionThirdOption:
        'Poco cemento esposto (20%), parquet su cemento',
      shortDescriptionFourthOption: 'Cemento principalmente esposto (70%)',
      shortDescriptionFifthOption:
        'Cemento esposto in soffitto, pareti e pavimento',
      claddingOptions: {
        custom: 'Personalizzato',
        standard: 'Standard',
        concrete100: '100mm (o più) calcestruzzo',
        concrete80: '80mm calcestruzzo',
        aeratedConcrete: 'Calcestruzzo cellulare',
        gypsum13: 'Gesso 13mm',
        lightBrick: 'Mattone leggero',
        lwa: 'Aggregato leggero',
        solidWood40: 'Legno massiccio (spessore > 40mm)',
        woodPanel15: 'Pannello legno 15mm',
        heavyBrick: 'Mattone pesante (compatto)',
      },
      furnitureOptions: {
        none: 'Nessuno',
        standard: 'Standard',
        light: 'Leggero',
        medium: 'Medio',
        heavy: 'Pesante',
      },
    },
    airLeakage: {
      tekStandard: 'Standard TEK',
      n50: 'Tasso di perdita n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Regolamento edilizio 1950–1969',
        TEK70: 'Regolamento edilizio 1970–1979',
        TEK80: 'Regolamento edilizio 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Elimina finestra',
      confirmDelete: 'Eliminare questa finestra?',
      gValue: 'Valore g',
      frameFraction: 'Fattore di telaio',
      shadingFactor: 'Fattore di ombreggiamento (0-1)',
      externalBlinds: 'Veneziane esterne (gt)',
      externalBlindsGt: 'Veneziane esterne gt',
      externalScreen: 'Tenda esterna (gt)',
      externalScreenGt: 'Tenda esterna gt',
      internalShading: 'Schermatura solare interna (gt)',
      internalShadingGt: 'Schermatura solare interna gt',
      windowTypes: {
        none: 'Nessuno',
        custom: 'Personalizzato',
        singleGlass: 'Vetro singolo',
        twoLayerGlass: 'Vetro doppio accoppiato',
        twoLayerEnergyGlass: 'Vetro doppio a bassa emissività',
        twoLayerSolarReflective: 'Vetro doppio riflettente',
        threeLayerEnergyGlass: 'Vetro triplo a bassa emissività',
      },
    },
    doors: {
      deleteDoor: 'Elimina porta',
      confirmDelete: 'Eliminare questa porta?',
      type: 'Tipo di porta',
      doorTypes: {
        custom: 'Personalizzato',
        standard: 'Standard',
        insulated: 'Isolata',
        normal: 'Normale',
        wellInsulated: 'Ben isolata',
        uninsulated: 'Non isolata',
      },
    },
    gates: {
      deleteGate: 'Elimina cancello',
      confirmDelete: 'Eliminare questo cancello?',
      type: 'Tipo di cancello',
      gateTypes: {
        custom: 'Personalizzato',
        standard: 'Standard',
        insulated: 'Isolato',
        sectional: 'Porta sezionale',
        roller: 'Porta avvolgibile',
        wellInsulated: 'Ben isolato',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        "Questi valori non vengono utilizzati nella creazione dell'etichetta energetica. Viene considerato solo il controllo presenza per l'illuminazione.",
      hotWater: 'Acqua calda',
      equipment: 'Attrezzature tecniche',
      occupancy: 'Persone',
      weekday: 'Giorno feriale (260 giorni)',
      weekend: 'Fine settimana (105 giorni)',
      resetToStandards: 'Ripristina a',
      hourlyProfile: 'Profilo orario',
      editHourlyValues: 'Modifica valori orari',
      peak: 'Picco',
      avg: 'Media',
      daily: 'Giornaliero',
      annual: 'Annuale',
      appliances: 'Elettrodomestici',
      appliancesDescription:
        "Ridurre il fabbisogno elettrico collegando gli elettrodomestici all'acqua calda.",
      dishwasherLabel: 'Lavastoviglie (acqua calda)',
      washingMachineLabel: 'Lavatrice (acqua calda)',
      tumbleDryerLabel: 'Asciugatrice (acqua calda)',
      applianceShareLabel: 'Quota termica [%]',
      heatGainShareLabel: 'Apporto di calore alla zona [1-100%]',
      lampTypes: 'Tipi di lampada',
      lampType: 'Tipo di lampada',
      selectLampType: 'Seleziona tipo di lampada',
      ballast: 'Alimentatore',
      electronic: 'Elettronico',
      electromechanical: 'Elettromeccanico',
      sharePercent: 'Quota (%)',
      efficiencyFactorFL: 'Fattore di efficienza (FL)',
      lampTypeNames: {
        ledNew: 'LED dal 2016 e più recenti',
        ledOld: 'LED dal 2010–2015',
        fluorescentT5: 'Tubo fluorescente T5',
        fluorescentT8: 'Tubo fluorescente T8',
        metalHalide: 'Lampada ad alogenuri metallici',
        highPressureSodium: 'Lampada al sodio ad alta pressione',
        compactFluorescent: 'Lampada fluorescente compatta',
        halogen: 'Lampada alogena',
        incandescent: 'Lampada a incandescenza',
      },
      addLampType: 'Aggiungi tipo di lampada',
      deleteLampType: 'Eliminare questo tipo di lampada?',
    },
    heatingEmissionSystem: 'Sistema di emissione del calore',
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Radiatore/convettore con valvola termostatica o regolatore locale',
      radiator_thermostat_60_40:
        'Radiatore/convettore con valvola termostatica o regolatore locale',
      radiator_thermostat_40_35:
        'Radiatore/convettore con valvola termostatica o regolatore locale',
      radiator_sd_80_60: 'Radiatore/convettore collegato al BMS',
      radiator_sd_60_40: 'Radiatore/convettore collegato al BMS',
      radiator_sd_40_35: 'Radiatore/convettore collegato al BMS',
      fan_coil_heat_pump:
        'Ventilconvettore / unità interna pompa di calore / trave fredda attiva / riscaldamento tramite aria di ventilazione',
      floor_heating_thermostat:
        'Riscaldamento a pavimento con valvola termostatica o regolatore locale',
      floor_heating_sd: 'Riscaldamento a pavimento collegato al BMS',
      panel_heater_pre_2010: 'Pannello radiante \u2013 prima del 2010',
      panel_heater_post_2010: 'Pannello radiante \u2013 dopo il 2010',
    },
    coolingEmissionSystem: 'Sistema di emissione del freddo',
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Trave fredda passiva con valvola termostatica o regolatore locale',
      chilled_beam_sd: 'Trave fredda passiva collegata al BMS',
      fan_coil_cool_pump:
        'Trave fredda attiva / ventilconvettore con regolatore locale',
      fan_coil_cool_pump_sd:
        'Trave fredda attiva / ventilconvettore collegato al BMS',
      floor_cooling_thermostat:
        'Raffrescamento a pavimento con regolatore locale',
      floor_cooling_sd: 'Raffrescamento a pavimento collegato al BMS',
      chilled_ceiling_thermostat: 'Soffitto freddo con regolatore locale',
      chilled_ceiling_sd: 'Soffitto freddo collegato al BMS',
    },
    effectiveSetpoint: 'Setpoint effettivo',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Collega zone',
    resetLayout: 'Reimposta layout',
    resetLayoutConfirm:
      'Reimpostare il layout della mappa? Tutte le zone tornano alla posizione suggerita.',
    confirmLink: 'Conferma collegamento',
    linkDialogTitle: 'Collega zone termiche',
    linkingZones: 'Collegamento zone',
    sourceZone: 'Zona sorgente',
    targetZones: 'Zone destinazione',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst:
      'Seleziona prima la zona sorgente, poi le zone destinazione',
    minTwoZones: 'Seleziona almeno 2 zone da collegare',
    linkSuccess: 'Zone collegate con successo',
    externalZone: 'Zona esterna',
    zoneConnections: 'Accoppiamento zona',
    addConnection: 'Aggiungi accoppiamento',
    noConnections: 'Nessun accoppiamento di zona',
    connectionDeleted: 'Accoppiamento rimosso',
    deleteConnectionError: 'Impossibile eliminare il collegamento',
    connectionAdded: 'Accoppiamento aggiunto',
    connectionUpdated: 'Accoppiamento aggiornato',
    editConnection: 'Modifica accoppiamento',
    deleteConnection: 'Elimina accoppiamento',
    confirmDeleteConnection: 'Rimuovere accoppiamento zona?',
    connectToExisting: 'Zona esistente',
    connectToExternal: 'Zona esterna',
    chooseConnectionType: 'Connetti a',
    zoneMap: 'Mappa delle zone',
    zoneMapEmpty: 'Nessun collegamento tra zone',
    notLinked: 'Non collegata',
    autoLinked: 'Collegata automaticamente',
    linkModeHintSource: 'Clicca sulla zona di origine',
    deleteModeHint: 'Clicca sulla zona da cui eliminare i collegamenti',
    ventilation: 'Ventilazione',
    zoneMapSubtitle: 'Sposta le zone per regolare il layout.',
    noVentilationUnits: 'Nessuna unità di ventilazione disponibile',
    noHeatingCoolingModules:
      'Nessun riscaldamento o raffrescamento disponibile',
    linkAny: 'Collega',
    linkModeHintSourceAny: 'Clicca sulla sorgente',
    linkModeHintTargetAny:
      'Clicca sulla destinazione o scegli una zona esterna',
    deleteModeHintAny:
      "Clicca sulla zona o sull'unità di ventilazione da cui eliminare i collegamenti",
    linkModeHintTarget:
      'Clicca sulla zona di destinazione oppure scegli zona esterna',
  },

  analytics: {
    energyToggle: 'Energia',
    analyticsToggle: 'Analisi',
    compareToggle: 'Confronta',
    runSimulation: 'Avvia simulazione',
    runCoverNeedSimulation: 'Avvia simulazione con requisiti minimi',
    coverNeedTooltip:
      'Esegue la simulazione con sistemi fittizi ai requisiti minimi, coprendo tutto il fabbisogno energetico dove i sistemi mancano o sono insufficienti',
    coverNeedAssumptionsTitle: 'Ipotesi della simulazione con requisiti minimi',
    simulating: 'Simulazione in corso...',
    exportToExcel: 'Esporta in Excel',
    sendToEnova: 'Invia a Enova',
    resendToEnova: 'Invia di nuovo a Enova',
    downloadEnovaPdf: 'Scarica PDF Enova',
    sentToEnovaSuccess: 'Inviato a Enova',
    sendToEnovaError: 'Invio a Enova non riuscito',
    simulationStartedRefresh:
      'I calcoli sono iniziati, aggiorna o torna a questa pagina dopo 10 secondi',
    simulationStartError: 'Impossibile avviare la simulazione',
    runRequiresZoneSelection:
      'Seleziona almeno una zona prima di avviare la simulazione.',
    solarNotIncludedInZones:
      'La produzione solare è calcolata a livello di edificio e non è inclusa nei risultati e nei confronti per zona.',
    resultsCalculatedAt: 'Calcolato il {datetime}',
    resultsCalculatedWithStandard: 'Calcolato il {datetime} secondo {standard}',
    enovaMissingTiltakDescription:
      'Compila la descrizione nella sezione Interventi della Classe energetica.',
    enovaNoIncludedActions:
      "Attiva almeno un intervento da includere oppure deseleziona 'Includi interventi' e fornisci una descrizione.",
    enovaMissingActionDescriptions: 'Compila le descrizioni per: {actions}',
    enovaMissingCredentials:
      'Compila {fields} nel tuo profilo utente prima di inviare a Enova.',
    enovaNoMatrikkelSelected:
      'Seleziona almeno una bruksenhet nella sezione Matrikkeldata prima di inviare a Enova.',
    enovaZonesNotSimulated:
      'Esegui la simulazione dell’etichetta energetica per le zone selezionate prima di inviare a Enova.',
    enovaNonResidentialMultipleUnits:
      'È possibile selezionare una sola unità per le sezioni non residenziali.',
    confirmSendToEnovaMessage: 'Sei sicuro di voler inviare a Enova?',
    enovaSendWithMessagesWarning:
      'La simulazione contiene {count} messaggi. Controllali prima di inviare a Enova.',
    simulationProgress: "Simulazione energetica dell'edificio in corso...",
    simulationMessages: 'Messaggi di simulazione',
    energyCalcWithStandard:
      'Calcoli energetici secondo lo standard {standard}.',
    energyCalc: 'Calcoli energetici',
    noResults:
      'Nessun risultato di simulazione disponibile. Avvia una simulazione per visualizzare i dati energetici.',
    analyticsPlaceholder: 'I grafici di analisi saranno visualizzati qui.',
    // Chart titles & descriptions
    monthlyEnergyBudget: 'Budget energetico mensile (domanda)',
    deliveredEnergyTitle: 'Fonti di energia fornita',
    deliveredEnergyDesc:
      "L'energia totale fornita rappresenta tutte le fonti energetiche fornite all'edificio.",
    energyComparisonTitle: 'Confronto energetico (Netto / Perdita / Lordo)',
    energyComparisonDesc:
      "Confronta il fabbisogno energetico netto, le perdite di distribuzione e l'energia lorda per ogni categoria. Lordo = Netto + Perdita.",
    // Chart labels
    showTemperature: 'Mostra linea temperatura',
    energySourcesChartLabel: 'Fonti energetiche',
    totalDeliveredEnergy: 'Energia totale fornita',
    visible: 'Visibile',
    noData: 'Nessun dato',
    nettEnergy: 'Energia netta',
    grossEnergy: 'Energia lorda',
    distributionLossLabel: 'Perdita di distribuzione e accumulo',
    noMonthlyData:
      'I dati mensili non sono disponibili per questa simulazione.',
    monthlyChartHelp:
      'Ogni barra impilata rappresenta il fabbisogno energetico netto mensile suddiviso per categoria.',
    netEnergyDemand: 'Fabbisogno energetico netto',
    distributionLosses: 'Perdite di distribuzione e accumulo',
    grossEnergyDemand: 'Fabbisogno energetico lordo',
    energySourcesTitle: 'Fonti energetiche (Energia fornita)',
    deliveredExportedEnergyTitle: 'Energia fornita ed esportata',
    climaCorrectedEnergyTitle:
      'Energia consegnata ed esportata corretta climaticamente',
    netEnergyTitle: 'Energia netta (Fabbisogno energetico netto)',
    distributionLossTitle:
      'Perdite di distribuzione (Distribuzione e perdite di accumulo)',
    grossEnergyTitle: 'Energia lorda (Fabbisogno energetico lordo)',
    category: 'Categoria',
    value: 'Valore',
    unit: 'Unità',
    co2: 'CO₂ kg',
    energyType: 'Tipo di energia',
    electricityCategory: '1. Elettricità',
    fossilCategory: '2-3. Combustibili fossili',
    renewableCategory: '4. Riscaldamento rinnovabile',
    districtCategory: '5. Energia di rete',
    otherCategory: '6-8. Altre fonti',
    totalCategory: 'Totale',
    elSpecific: 'El. voci specifiche',
    elHeating: 'El. per riscaldamento ambienti',
    elCooling: 'El. per sistema di raffreddamento',
    elDHW: 'El. per acqua calda sanitaria',
    elProducedUsed: 'El. produzione per uso proprio',
    elProducedExported: 'El. produzione esportata',
    oil: 'Petrolio',
    gas: 'Gas',
    solidFuel: 'Combustibile solido',
    solidBiofuel: 'Biocombustibile solido',
    liquidBiofuel: 'Biocombustibile liquido',
    gaseousBiofuel: 'Biocombustibile gassoso',
    districtHeating: 'Teleriscaldamento',
    districtCooling: 'Teleraffrescamento',
    other: 'Altro',
    sumDelivered: 'Totale',
    spaceHeating: 'Riscaldamento ambienti',
    ventilationHeating: 'Riscaldamento ventilazione',
    hotWater: 'Acqua calda',
    spaceCooling: 'Raffrescamento ambienti',
    ventilationCooling: 'Raffrescamento ventilazione',
    fans: 'Ventilatori',
    pumps: 'Pompe',
    lighting: 'Illuminazione',
    technicalEquipment: 'Attrezzatura tecnica',
    total: 'Totale',
    // Heat loss
    heatLossTitle: 'Dispersione termica',
    heatLossDesc:
      'Ripartizione della dispersione termica per componente. Valori in W/m²K.',
    hlWalls: 'Pareti',
    hlRoof: 'Copertura',
    hlFloor: 'Pavimento verso il terreno',
    hlWindows: 'Finestre',
    hlDoors: 'Porte',
    hlThermalBridge: 'Ponti termici',
    hlInfiltration: 'Infiltrazione',
    hlVentilation: 'Ventilazione',
    hlTotal: 'Totale',
    // Bilancio delle dispersioni termiche (tabella 3 NS 3031:2025)
    hlBudgetTitle: 'Bilancio delle dispersioni termiche',
    hlBudgetCategory: 'Voce di dispersione termica',
    hlBudgetValue: 'Coefficiente di dispersione termica',
    hlWindowsDoors: 'Finestre e porte',
    hlTransmissionSum: 'Coefficiente di dispersione, trasmissione, somma 1–5',
    hlClimateScreenSum: 'Coefficiente di dispersione, involucro, somma 1–6',
    hlTotalSum: 'Coefficiente di dispersione, totale, somma 1–7',
    // Energia primaria
    peDeliveredEnergy: 'Energia fornita (elettricità)',
    peDeliveredFuel: 'Combustibile fornito',
    peDistrictHeating: 'Teleriscaldamento',
    peDistrictCooling: 'Teleraffrescamento',
    peOtherDelivered: 'Altra energia fornita',
    peElExport: 'Produzione el. per esportazione',
    energyLabelTitle: 'Etichetta energetica',
    supplementaryEnergyTitle: 'Energia supplementare',
    primaryEnergyFactorsTitle: 'Fattori di ponderazione energia primaria',
    carCharging: 'Ricarica auto',
    otherEnergyNeeded: 'Altro fabbisogno energetico',
    energyNeedForOtherBuildings: 'Fabbisogno energetico altri edifici',
    peFossilOil: 'Olio fossile',
    peFossilGas: 'Gas fossile',
    peFossilSolid: 'Combustibile solido fossile',
    peBioOil: 'Bioolio',
    peBioGas: 'Biogas',
    peBioSolid: 'Biocombustibile solido',
    ventilationSpecsTitle: 'Specifiche ventilazione e ventilatore',
    specificFanPower: 'Potenza specifica ventilatore (SFP)',
    specificAirFlowIn: 'Portata specifica mandata in orario di esercizio',
    specificAirFlowOut: 'Portata specifica mandata fuori orario di esercizio',
    specificExhaustAirFlowIn:
      'Portata specifica estrazione in orario di esercizio',
    specificExhaustAirFlowOut:
      'Portata specifica estrazione fuori orario di esercizio',
    hcsHeatingTitle: 'Sistemi di riscaldamento',
    hcsCoolingTitle: 'Sistemi di raffrescamento',
    hcsType: 'Tipo',
    hcsHeatingFactor: 'Rendimento fattore di calore',
    hcsCoolingFactor: 'Rendimento fattore di raffrescamento',
    hcsEnergyCoverage: 'Grado di copertura energetica',
    hcsInndata: 'Dati di ingresso',
    hcsInstalledHeatingEffect:
      'Potenza specifica installata per riscaldamento ambienti e ventilazione',
    hcsInstalledCoolingEffect:
      'Potenza specifica installata per raffrescamento ambienti e ventilazione',
    hcsSetpointInOperation:
      'Temperatura di set-point equivalente in funzionamento',
    hcsSetpointOutOfOperation:
      'Temperatura di set-point equivalente fuori funzionamento',
    wpeTitle: 'Energia consegnata pesata corretta climaticamente',
    wpeColSource: 'Fonte energetica',
    wpeColDelivered: 'Energia consegnata ed esportata corretta climaticamente',
    wpeColFactor: 'Fattore di ponderazione',
    wpeColWeighted: 'Energia consegnata pesata corretta climaticamente',
    wpeTotal: 'Totale, somma 1-6',
    wpeElectricity: 'Elettricità consegnata',
    wpeSolidBio: 'Biocombustibile solido consegnato',
    wpeLiquidBio: 'Biocombustibile liquido consegnato',
    wpeGasBio: 'Biocombustibile gassoso consegnato',
    wpeSolidFossil: 'Combustibile fossile solido consegnato',
    wpeLiquidFossil: 'Combustibile fossile liquido consegnato',
    wpeGasFossil: 'Combustibile fossile gassoso consegnato',
    wpeDistrictHeating: 'Teleriscaldamento consegnato',
    wpeDistrictCooling: 'Teleraffrescamento consegnato',
    wpeOther: 'Altri vettori energetici consegnati',
    wpeElExport: 'Produzione elettrica per esportazione (detrazione)',
    ekBasisHeader: 'Base per la classe energetica',
    ekValueHeader: 'Valore',
    ekSpecificWeighted:
      'Energia consegnata pesata corretta climaticamente specifica',
    meTitle: 'Consumo energetico misurato (kWh/anno)',
    meColSource: 'Vettore energetico',
    meColYearGroup: 'Anno',
    meColAverage: 'Media',
    meTotalDelivered: 'Energia consegnata totale',
    meTotalNetDelivered:
      'Energia netta consegnata totale (meno eventuale esportazione)',
    icTitle: 'Temperatura interna',
    icSubtitle: 'Media mensile basata sui valori orari',
    icZoneLabel: 'Zona',
    icSingleZoneLabel: 'Temperatura interna',
    dhcLocalHeatingElectricity: 'Riscaldamento locale — elettricità',
    dhcLocalHeatingFossilOil: 'Riscaldamento locale — olio fossile',
    dhcLocalHeatingFossilGas: 'Riscaldamento locale — gas fossile',
    dhcLocalHeatingFossilSolid:
      'Riscaldamento locale — combustibile solido fossile',
    dhcLocalHeatingBioOil: 'Riscaldamento locale — bioolio',
    dhcLocalHeatingBioGas: 'Riscaldamento locale — biogas',
    dhcLocalHeatingBioSolid: 'Riscaldamento locale — biocombustibile solido',
    dhcLocalDistrictHeating: 'Teleriscaldamento locale',
    dhcLocalHeatPump: 'Pompa di calore locale',
    dhcLocalHeatingOther: 'Riscaldamento locale — altre fonti',
    dhcCentralHeatPump: 'Pompa di calore centrale',
    dhcCentralHeatingElectricity: 'Riscaldamento centrale — elettricità',
    dhcCentralHeatingFossilOil: 'Riscaldamento centrale — olio fossile',
    dhcCentralHeatingFossilGas: 'Riscaldamento centrale — gas fossile',
    dhcCentralHeatingFossilSolid:
      'Riscaldamento centrale — combustibile solido fossile',
    dhcCentralHeatingBioOil: 'Riscaldamento centrale — bioolio',
    dhcCentralHeatingBioGas: 'Riscaldamento centrale — biogas',
    dhcCentralHeatingBioSolid:
      'Riscaldamento centrale — biocombustibile solido',
    dhcCentralDistrictHeating: 'Teleriscaldamento centrale',
    dhcCentralHeatingOther: 'Riscaldamento centrale — altre fonti',
    dhcCentralSolarThermal: 'Solare termico centrale',
    dhcCentralCogeneration: 'Cogenerazione centrale',
    dhcLocalCooling: 'Raffrescamento locale',
    dhcCentralCoolingAirWater: 'Raffrescamento centrale — aria/acqua',
    dhcCentralCoolingLiquidWater: 'Raffrescamento centrale — acqua/acqua',
    dhcCentralFreeCooling: 'Free cooling centrale',
    dhcCentralDistrictCooling: 'Teleraffrescamento centrale',
    // Carichi interni
    internalLoadsTitle: 'Carichi interni',
    internalLoadEnergyTitle: 'Carichi interni - Fabbisogno energetico',
    internalLoadHeatTitle: 'Carichi interni - Apporti di calore',
    ilLighting: 'Illuminazione',
    ilEquipment: 'Apparecchiature tecniche',
    ilHotWater: 'Acqua calda',
    ilPeople: 'Persone',
    internalLoadsChartTitle:
      'Carichi interni (Fabbisogno energetico vs Apporti di calore)',
    internalLoadsChartDesc:
      'Confronta il fabbisogno energetico e gli apporti di calore dalle fonti di carico interno.',
    ilEnergyNeed: 'Fabbisogno energetico',
    ilSpecificEnergyNeed: 'Fabbisogno energetico specifico',
    ilSpecificHeatGain: 'Apporto termico specifico',
    ilHeatGain: 'Apporto di calore',
    // Month names
    month: 'Mese',
    monthJan: 'Gen',
    monthFeb: 'Feb',
    monthMar: 'Mar',
    monthApr: 'Apr',
    monthMay: 'Mag',
    monthJun: 'Giu',
    monthJul: 'Lug',
    monthAug: 'Ago',
    monthSep: 'Set',
    monthOct: 'Ott',
    monthNov: 'Nov',
    monthDec: 'Dic',
    // Information table (general + climate)
    bdTitle: 'Informazioni',
    bdParameter: 'Generale',
    bdInputValue: 'Valore di ingresso',
    bdBuildingCategory: 'Categoria edificio',
    bdBuildingType: 'Tipo di edificio',
    bdYearOfConstruction: 'Anno di costruzione',
    bdTekStandard: 'Standard TEK',
    bdCalculationDate: 'Data di calcolo',
    bdClimateInformation: 'Clima',
    bdClimateStationSource: 'Fonte stazione climatica',
    bdClimateStation: 'Stazione climatica',
    bdClimateCorrectionFactor: 'Fattore di correzione climatica',
    bdYearlyAverageTemperature: 'Temperatura media annuale',
    efTitle: 'Flusso energetico',
    efColCategory: 'Voce energetica',
    efColNet: 'Fabbisogno energetico netto',
    efColDist: 'Perdite di distribuzione e accumulo',
    efColGross: 'Fabbisogno energetico lordo',
    efColSpf: 'SPF',
    efColDelivered: 'Energia fornita',
    efTotal: 'Totale',
    // Fattori di ponderazione vettori energetici (T.2 NS 3031:2025)
    wfTitle: 'Fattori di ponderazione dei vettori energetici',
    wfType: 'Tipo',
    wfWeightFactor: 'Fattore di ponderazione',
    wfClimateFactor: 'Fattore gas serra (equivalente CO²)',
    wfEnergyPrice: "Prezzo dell'energia",
    wfOtherWeighting: 'Altra ponderazione',
    wfElectricity: 'Elettricità fornita',
    wfBioSolid: 'Biocombustibile solido',
    wfBioLiquid: 'Biocombustibile liquido',
    wfBioGas: 'Biocombustibile gassoso',
    wfFossilSolid: 'Combustibile fossile solido',
    wfFossilLiquid: 'Combustibile fossile liquido',
    wfFossilGas: 'Combustibile fossile gassoso',
    wfDistrictHeating: 'Teleriscaldamento',
    wfDistrictCooling: 'Teleraffrescamento',
    wfOther: 'Altro',
    wfExportedElectricity: 'Elettricità esportata',
    // Sistemi di distribuzione
    dsTitle: 'Sistemi di distribuzione',
    dsCategory: 'Parametro',
    dsValue: 'Valore di ingresso',
    dsRoomHeating: 'Riscaldamento ambienti',
    dsVentilationHeating: 'Riscaldamento per ventilazione',
    dsDhwCirculation: 'Circolazione acqua calda',
    dsRoomCooling: 'Raffrescamento ambienti',
    dsVentilationCooling: 'Raffrescamento per ventilazione',
    dsPipeLength: 'Lunghezza tubazioni per superficie riscaldata',
    dsPumpPower: 'Potenza specifica delle pompe',
    // Elettricità (tabella T.2 NS 3031:2025)
    elTitle: 'Elettricità',
    elCategory: 'Parametro',
    elValue: 'Valore di ingresso',
    elSolarEfficiency: 'Efficienza annua del sistema fotovoltaico',
    elSolarInstalled: 'Potenza installata del fotovoltaico (Ppeak)',
    elSolarCoverage:
      'Copertura solare del fabbisogno energetico specifico elettrico',
    elWindCoverage:
      'Copertura eolica del fabbisogno energetico specifico elettrico',
    elChpEfficiency:
      'Efficienza media annua della produzione elettrica da cogenerazione',
    elChpCoverage:
      'Copertura da cogenerazione del fabbisogno energetico specifico elettrico',
  },

  energyLabelConfig: {
    // air leakage
    airLeakageTitle: "Perdita d'aria",
    airLeakageMeasured: "Perdita d'aria misurata",
    airLeakageMeasuredDate: 'Data di misurazione',
    airLeakageGradeAHint:
      "La classe A richiede una perdita d'aria misurata con data di misurazione. Senza di essa l'etichetta è limitata a B.",
    // actions
    actionsTitle: 'Azioni',
    includeMeasures: 'Includi misure in valutazione',
    includeActivatedActions: 'Includi azioni attivate',
    loadingActions: 'Caricamento azioni…',
    actionNameVentilation: 'Azione ventilazione',
    actionNameHeating: 'Azione riscaldamento e raffrescamento',
    actionNameLighting: 'Azione illuminazione',
    actionNameSolar: 'Azione pannelli solari',
    actionNameControl: 'Azione Controllo & Regolazione',
    actionsDescription:
      'Se non sono incluse misure, descrivi invece il motivo (ad es., nuova costruzione).',
    includedMeasuresInfo:
      "L'elenco delle misure incluse contiene una valutazione dei costi e delle conseguenze riguardanti umidità e clima interno per ciascuna misura energetica. L'elenco può essere utilizzato come base per pianificare un programma di manutenzione e riqualificazione dell'edificio.",
    description: 'Descrizione',
    // measured values
    measuredValuesTitle: 'Valori misurati',
    measuredValuesCheckbox: 'Valori misurati',
    measuredValuesDescription:
      'Misurazioni del consumo energetico per tipo di fonte negli ultimi 3 anni.',
    energySourcePlaceholder: 'Fonte energetica (kWh)',
    addMeasurement: 'Aggiungi misurazione',
    confirmDeleteMeasurement: 'Eliminare questa riga di misurazione?',
    // energy source options
    deliveredElectricity: 'Elettricità consegnata (kWh)',
    exportedElectricity: 'Elettricità esportata (kWh)',
    fossilOil: 'Olio fossile (kWh)',
    fossilGas: 'Gas fossile (kWh)',
    fossilSolidFuel: 'Combustibile solido fossile (kWh)',
    bioOil: 'Bio-olio (kWh)',
    bioGas: 'Biogas (kWh)',
    bioSolidFuel: 'Biocombustibile solido (kWh)',
    districtHeating: 'Teleriscaldamento (kWh)',
    districtCooling: 'Teleraffrescamento (kWh)',
    other: 'Altro (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Dati catastali',
    noUnitsFound: 'Nessuna unità trovata',
    street: 'Indirizzo',
    addressCode: 'Codice indirizzo',
    postcode: 'Codice postale',
    city: 'Città',
    municipality: 'Comune',
    municipalityNumber: 'Numero del comune',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Numero del diritto di locazione',
    buildingNumber: "Numero dell'edificio",
    buildingType: 'Tipo di edificio',
    buildingStatus: "Stato dell'edificio",
    industryType: 'Tipo di industria',
    unitNumber: "Numero dell'unità",
    unitId: 'ID unità',
    unitType: 'Tipo di unità',
    sectionNumber: 'Numero della sezione',
    sectionType: 'Tipo di sezione',
  },

  zoneSelection: {
    title: 'Zone da simulare',
    selectAll: 'Seleziona tutto',
    deselectAll: 'Deseleziona tutto',
    selected: '{count} di {total} selezionati',
  },

  buildingTool: {
    showAll: 'Mostra tutto',
    hideAll: 'Nascondi tutto',
    updateZone: 'Aggiorna zona',
    deleteZone: 'Elimina zona',
    title: 'Strumento edificio',
    description:
      "Disegna un poligono sulla mappa per delineare la pianta dell'edificio, regola i parametri e crea una zona con pareti.",
    numberOfFloors: 'Numero di piani',
    floorHeight: 'Altezza piano (m)',
    startFloor: 'Piano iniziale',
    wallSegments: 'Segmenti di parete',
    totalPerimeter: 'Perimetro totale',
    creating: 'Creazione...',
    createZoneAndWalls: 'Crea zona e pareti',
    createSuccess: 'Zona e {count} parete/i create con successo',
    createError: 'Impossibile creare zona e pareti',
    joinBearings: 'Unisci per orientamento',
    splitBearings: 'Mostra tutti i segmenti',
    joinButton: 'Unisci',
    splitButton: 'Dividi',
    floorArea: 'Superficie pavimento (m²)',
    roofArea: 'Superficie tetto (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Clicca su un edificio per selezionarne la pianta',
    noBuildingFound: 'Nessun edificio trovato',
    createAnother: "Crea un'altra zona",
    autoSelectTooltip: 'Selezione auto',
    drawPolygonTooltip: 'Disegna poligono',
    drawStackedTooltip: 'Aggiungi piano sopra zona',
    drawStackedTooltipDisabled: 'Aggiungi piano sopra zona (zona richiesta)',
    drawStackedHint: 'Clicca su una zona per aggiungere una copia sopra',
    snapToggleOn: 'Aggancio attivo',
    snapToggleOff: 'Aggancio disattivato',
    splitTooltip: 'Dividi una zona',
    splitTooltipDisabled: 'Dividi una zona (zona richiesta)',
    splitTargetHint: 'Clicca su una zona da dividere',
    view3dTooltip: 'Vista 3D',
    splitPanelTitle: 'Dividi zona',
    splitPanelDescription:
      'Trascina i cursori per posizionare il taglio. La zona viene divisa in due metà.',
    splitPanelPickTargetHint:
      'Clicca su una zona della mappa per scegliere quale dividere.',
    splitPanelSplittingZone: 'Divisione: {name}',
    splitPanelCutPositionLabel: 'Posizione di taglio: {value}',
    splitPanelCutAngleLabel: 'Angolo di taglio: {value}°',
    splitPanelCutLengthLabel: 'Lunghezza di taglio: {value}',
    splitPanelCutOffsetLabel: 'Sfalsamento di taglio: {value}',
    splitPanelConfirm: 'Conferma divisione',
    splitPanelCommitting: 'Divisione in corso…',
    errorUpdateZone: 'Impossibile aggiornare la zona',
    errorCreateStackedZone: 'Impossibile aggiungere un piano sopra la zona',
    errorSplitZone: 'Impossibile dividere la zona',
    errorDeleteZone: 'Impossibile eliminare la zona',
  },

  underDevelopment: 'Questa pagina è in fase di sviluppo.',

  // excel export labels for the input data sheet
  excelExport: {
    // column headers
    headerSection: 'Sezione',
    headerName: 'Nome',
    headerParameter: 'Parametro',
    headerValue: 'Valore',
    headerUnit: 'Unità',
    // sheet tab name
    inputDataSheetName: 'Dati di input',
    // boolean values
    boolYes: 'Sì',
    boolNo: 'No',
    // section names
    sectionThermalZones: 'Zone termiche',
    sectionExteriorWalls: 'Pareti esterne',
    sectionHvacUnits: 'Unità HVAC',
    sectionHeatingCoolingModules: 'Moduli riscaldamento/raffrescamento',
    sectionCentralEnergyModules: 'Moduli energia centrale',
    sectionHeatPumps: 'Pompe di calore',
    sectionDistrictHeating: 'Teleriscaldamento',
    sectionCombustionBoilers: 'Caldaie a combustione',
    sectionElectricBoilers: 'Caldaie elettriche',
    sectionSolarThermal: 'Solare termico',
    sectionOtherEnergySources: 'Altre fonti energetiche',
    sectionSolarPv: 'Solare FV',
    sectionDomesticHotWater: 'Acqua calda sanitaria',
    sectionPipeConfigurations: 'Configurazioni tubazioni',
    sectionProductionEquipment: 'Attrezzature di produzione',
    sectionExcessEnergy: 'Energia in eccesso',
    // concept matches common.* but formatting differs for sheet readability
    area: 'Area',
    uValue: 'Valore U',
    yearInstalled: 'Anno di installazione',
    energySource: 'Fonte energetica',
    systemEfficiency: 'Efficienza del sistema',
    usedForHeating: 'Usato per riscaldamento',
    usedForCooling: 'Usato per raffrescamento',
    usedForDHW: 'Usato per ACS',
    maxCapacity: 'Capacità max.',
    heatingCapacity: 'Capacità di riscaldamento',
    cop: 'COP',
    heatingEffect: 'Potenza di riscaldamento',
    coolingEffect: 'Potenza di raffrescamento',
    co2eEmissionFactor: 'Fattore emissione CO\u2082e',
    energyPrice: 'Prezzo energia',
    power: 'Potenza',
    // entity prefixes
    prefixWall: 'Parete',
    prefixWindow: 'Finestra',
    prefixDoor: 'Porta',
    prefixGate: 'Portone',
    prefixPipe: 'Tubo',
    prefixHeatingBattery: 'Batteria di riscaldamento',
    prefixCoolingBattery: 'Batteria di raffrescamento',
    prefixDxSystem: 'Sistema DX',
    prefixEnergySource: 'Fonte energetica',
    prefixTank: 'Serbatoio',
    prefixCopEntry: 'Voce COP',
    // thermal zones
    heatedFloorArea: 'Superficie riscaldata (BRA)',
    numberOfFloors: 'Numero di piani',
    floorHeight: 'Altezza piano',
    indoorTemperature: 'Temperatura iniziale',
    zoneClimate: 'Clima della zona',
    airLeakageGrade: "Perdite d'aria - Grado",
    airLeakageN50: "Perdite d'aria - n50",
    setpointHeating: 'Setpoint - Riscaldamento',
    setpointCooling: 'Setpoint - Raffrescamento',
    thermalBridgeType: 'Ponte termico - Tipo',
    thermalBridgePsiValue: 'Ponte termico - valore \u03C8',
    floorType: 'Pavimento verso il terreno - Tipo',
    floorArea: 'Pavimento verso il terreno - Area',
    floorUValue: 'Pavimento verso il terreno - Valore U',
    floorHeatLossCoeff: 'Pavimento verso il terreno - Coefficiente dispersione',
    roofType: 'Tetto - Tipo',
    roofArea: 'Tetto - Area',
    roofUValue: 'Tetto - Valore U',
    roofAngle: 'Tetto - Angolo',
    roofWindowArea: 'Tetto - Area finestra',
    roofWindowUValue: 'Tetto - Finestra valore U',
    roofWindowGValue: 'Tetto - Finestra valore g',
    basementArea: 'Seminterrato - Superficie pavimento',
    basementWallPerimeter: 'Seminterrato - Perimetro interrato',
    basementFillHeight: 'Seminterrato - Profondità sotto il terreno',
    basementWallThickness: 'Seminterrato - Spessore parete',
    basementWallUValue: 'Seminterrato - Parete valore U',
    basementFloorUValue: 'Seminterrato - Pavimento valore U',
    groundThermalConductivity: 'Terreno - Conduttività termica',
    groundHeatCapacity: 'Terreno - Capacità termica',
    groundPenetrationDepth: 'Terreno - Profondità di penetrazione',
    thermalMassCategory: 'Massa termica - Categoria',
    thermalMassHeatCapacity: 'Massa termica - Capacità termica',
    thermalMassNormalized: 'Massa termica - Capacità normalizzata',
    // windows
    gValue: 'Valore g',
    shadingFactor: 'Fattore di ombreggiamento',
    externalBlinds: 'Tende esterne',
    externalBlindsGt: 'Tende esterne Gt',
    externalScreen: 'Schermo esterno',
    externalScreenGt: 'Schermo esterno Gt',
    internalShading: 'Schermatura interna',
    internalShadingGt: 'Schermatura interna Gt',
    // hvac
    heatRecoveryType: 'Tipo recupero calore',
    motorType: 'Tipo motore',
    flowType: 'Tipo flusso',
    sfpSupply: 'SFP (mandata)',
    sfpExtract: 'SFP (estrazione)',
    sfpNonOperating: 'SFP fuori servizio',
    coverageArea: 'Area di copertura',
    coverageVolume: 'Volume di copertura',
    fanPowerSupply: 'Potenza ventilatore (mandata)',
    fanPowerExtract: 'Potenza ventilatore (estrazione)',
    heatRecoveryEfficiency: 'Efficienza recupero calore',
    frostProtection: 'Protezione antigelo',
    frostProtectionTemperature: 'Temperatura protezione antigelo',
    airVolumeOperatingSupply: 'Volume aria funzionamento (mandata)',
    airVolumeCapacitySupply: 'Volume aria capacità (mandata)',
    airVolumeNonOperatingSupply: 'Volume aria fuori servizio (mandata)',
    airVolumeOperatingExtract: 'Volume aria funzionamento (estrazione)',
    airVolumeCapacityExtract: 'Volume aria capacità (estrazione)',
    airVolumeNonOperatingExtract: 'Volume aria fuori servizio (estrazione)',
    supplyTemperature: 'Temperatura di mandata',
    onlyNaturalPassiveVentilation: 'Solo ventilazione naturale/passiva',
    batteryEer: 'EER',
    // heating/cooling modules
    systemType: 'Tipo di sistema',
    // central energy modules
    coolingOnly: 'Solo raffrescamento',
    ambientTemperature: 'Temperatura ambiente',
    tankPurpose: 'Scopo',
    tankVolume: 'Volume',
    tankInsulationGrade: 'Grado isolamento',
    tankHeatLossCoeff: 'Coefficiente dispersione termica',
    tankSetpointTemp: 'Temperatura setpoint',
    tankMaxTemp: 'Temperatura max.',
    tankMinTemp: 'Temperatura min.',
    // heat pumps
    heatPumpType: 'Tipo pompa di calore',
    nominalLoad: 'Carico nominale',
    minimumLoad: 'Carico minimo',
    degradationCoefficient: 'Coefficiente di degradazione',
    liquidSource: 'Fonte liquida',
    sourceTemperature: 'Temperatura sorgente',
    sourceYearlyAvgTemp: 'Temperatura media annua sorgente',
    sourceTempAmplitude: 'Ampiezza temperatura sorgente',
    copSourceTemp: 'Temp. sorgente',
    copMaxEffectLow: 'Effetto max. (bassa temp.)',
    copMaxEffectHigh: 'Effetto max. (alta temp.)',
    copFullLoadLow: 'COP pieno carico (bassa temp.)',
    copFullLoadHigh: 'COP pieno carico (alta temp.)',
    copNormalLoadLow: 'COP carico normale (bassa temp.)',
    copNormalLoadHigh: 'COP carico normale (alta temp.)',
    copLowLoadLow: 'COP carico parziale (bassa temp.)',
    copLowLoadHigh: 'COP carico parziale (alta temp.)',
    // combustion boilers
    boilerType: 'Tipo caldaia',
    efficiencyAtLowerLoad: 'Efficienza a carico parziale',
    effectAtFullLoad: 'Effetto a pieno carico',
    isCondensing: 'A condensazione',
    seasonalMeanTemperature: 'Temperatura media stagionale',
    fuelSource: 'Fonte combustibile',
    fuelEnergyContent: 'Contenuto energetico combustibile',
    fuelCo2EmissionFactor: 'Combustibile fattore CO\u2082',
    operatingStart: 'Inizio funzionamento',
    operatingEnd: 'Fine funzionamento',
    // electric boilers
    phi: 'Phi',
    insulationGrade: 'Grado isolamento',
    // solar thermal
    tilt: 'Inclinazione',
    collectorArea: 'Area collettore',
    pipeLength: 'Lunghezza tubo',
    pipeUValue: 'Tubo valore U',
    efficiencyAtNormalConditions: 'Efficienza in condizioni normali',
    heatLossLinearCoefficient: 'Coefficiente lineare dispersione',
    heatLossCoefficient: 'Coefficiente di dispersione',
    // other energy sources
    fuelType: 'Tipo combustibile',
    // solar pv
    panelArea: 'Area pannello',
    nominalEfficiency: 'Efficienza nominale',
    panelAngle: 'Angolo pannello',
    panelAzimuth: 'Azimut pannello',
    inverterEfficiency: 'Efficienza inverter',
    degradationLoss: 'Perdita degradazione',
    inverterLoss: 'Perdita inverter',
    transmissionProduct: 'Prodotto trasmissione (0-1)',
    temperatureCoefficient: 'Coefficiente temperatura (%/°C)',
    incidentAngleModifier: 'Modificatore angolo di incidenza (0-1)',
    heatLossFactor: 'Fattore dispersione termica',
    pvMountingType: 'Tipo montaggio',
    windExposure: 'Esposizione al vento',
    pvCellType: 'Tipo cella',
    // domestic hot water
    heaterType: 'Tipo scaldabagno',
    useNormedData: 'Usa dati normalizzati',
    placementType: 'Tipo posizionamento',
    volume: 'Volume',
    setpointTemperature: 'Temperatura setpoint',
    heatingElementPower: 'Potenza resistenza',
    specificHeatLoss: 'Dispersione specifica',
    maxPowerDemand: 'Potenza max. richiesta',
    usagePattern: 'Profilo di utilizzo',
    heatContributionPercent: 'Contributo termico percentuale',
    distributionSystemType: 'Tipo sistema distribuzione',
    pipeSpecificLength: 'Lunghezza specifica tubo',
    tapCyclesPerDay: 'Cicli prelievo al giorno',
    pipesInHeatedRoom: 'Tubi in ambiente riscaldato',
    specificPumpPower: 'Potenza specifica pompa',
    pipeLinearUValue: 'Tubo valore U lineare',
    avgTempOutsideHeatedRoom: 'Temp. media fuori ambiente riscaldato',
    greyWaterRecovery: 'Recupero acque grigie',
    greyWaterEfficiency: 'Efficienza acque grigie',
    greyWaterShare: 'Quota acque grigie',
    greyWaterConnectionLossFactor: 'Acque grigie fattore perdita connessione',
    greyWaterPatternLossFactor: 'Acque grigie fattore perdita profilo',
    // pipe configurations
    waterSystemQuality: 'Qualità sistema idrico',
    pipeInsulationType: 'Tipo isolamento tubo',
    spp: 'SPP',
    constantFlow: 'Flusso costante',
    lengthOfPipe: 'Lunghezza tubo',
    percentageInHeatedSpace: 'Percentuale in spazio riscaldato',
    avgTempOutsideHeatedSpace: 'Temp. media fuori spazio riscaldato',
    temperatureReturn: 'Temperatura ritorno',
    temperatureSupply: 'Temperatura mandata',
    // production equipment
    eligibleForHarvesting: 'Idoneo al recupero',
    // excess energy
    medium: 'Fluido',
    temperature: 'Temperatura',
    amount: 'Quantità',
    ductShape: 'Forma condotto',
    diameter: 'Diametro',
    width: 'Larghezza',
    height: 'Altezza',
    airSpeed: 'Velocità aria',
  },

  actions: {
    ventilation: {
      pageTitle: 'Ventilazione',
      ventilationUnits: 'Unità di ventilazione',
      noHvacUnits:
        'Nessuna unità HVAC trovata. Aggiungere prima le unità HVAC nella sezione Sistemi HVAC.',
      usingUnits:
        "Utilizzo di {count} unità di ventilazione attivata/e dall'ispezione dell'edificio.",
      enableUnitsHint:
        "Abilitare le unità di ventilazione qui sotto per includerle nell'azione.",
    },
    lighting: {
      pageTitle: 'Illuminazione',
      thermalZones: 'Zone termiche',
      noZones:
        'Nessuna zona termica trovata. Aggiungere prima le zone termiche nella sezione Zone termiche.',
      usingZones:
        "Utilizzo di {count} zona/e termica/che attivata/e per l'azione illuminazione.",
      enableZonesHint:
        "Abilitare le zone termiche qui sotto per includerle nell'azione illuminazione.",
      unit: 'W/m\u00B2',
      presenceControl: 'Rilevamento presenza (illuminazione)',
      presenceControlLabel: 'Rilevamento presenza:',
      presenceYes: 'S\u00EC (fattore: {value})',
      presenceNo: 'No',
    },
    heating: {
      pageTitle: 'Riscaldamento & raffreddamento',
      thermalZones: 'Zone termiche',
      usingZones:
        "Utilizzo di {count} zona/e termica/che attivata/e per l'azione di riscaldamento.",
      enableZonesHint:
        "Abilitare le zone termiche qui sotto per includerle nell'azione di riscaldamento.",
      addNewSystem: 'Aggiungi nuovo sistema',
      addSystemDialogTitle: 'Aggiungi nuovo sistema',
      template: 'Modello',
      systemName: 'Nome del sistema',
      priorityHelp: '1 = massima priorità',
      unnamed: 'Senza nome',
      chipNew: 'NUOVO',
      chipRemoved: 'RIMOSSO',
      chipModified: 'MODIFICATO',
      remove: 'Rimuovi',
      delete: 'Elimina',
      confirmDelete: 'Sei sicuro di voler eliminare questo sistema?',
      undo: 'Annulla',
      noExistingSystems:
        'Nessun sistema di riscaldamento/raffreddamento esistente in questa zona.',
      enableZoneHint:
        'Abilitare questa zona per configurare i sistemi di riscaldamento/raffreddamento.',
      existingSystems: '{count} sistema/i esistente/i',
      templateAirWaterHP: 'Pompa di calore aria/acqua',
      templateAirAirHP: 'Pompa di calore aria/aria',
      templateAirToAirHP: 'Pompa di calore aria/aria',
      templateGroundSourceHP: 'Pompa di calore geotermica',
      templateElectricBoiler: 'Caldaia elettrica',
      templateDistrictHeating: 'Teleriscaldamento',
      templateDistrictCooling: 'Teleraffrescamento',
    },
    solar: {
      pageTitle: 'Fotovoltaico',
      solarPvModules: 'Moduli fotovoltaici',
      noModules:
        'Nessun modulo fotovoltaico trovato. Aggiungere moduli nella sezione Fotovoltaico.',
      usingModules:
        "Utilizzo di {count} modulo/i fotovoltaico/i attivato/i dall'ispezione.",
      enableModulesHint:
        "Attivare i moduli fotovoltaici qui sotto per includerli nell'azione.",
      addNewModule: 'Aggiungi nuovo modulo',
      chipNew: 'Nuovo',
      noExistingModules: 'Nessun modulo fotovoltaico esistente.',
    },
    control: {
      pageTitle: 'Controllo & Regolazione',
      energyReductionPercent: 'Riduzione energetica [%]',
      energyReductionHint:
        "Riduzione percentuale dell'energia totale fornita rispetto alla simulazione di riferimento.",
    },
    overview: {
      overviewTitle: 'Panoramica delle azioni',
      combinedResults: 'Risultati di simulazione combinati',
      notSimulated: 'Non ancora simulato',
      noActiveActions:
        'Nessuna azione attiva. Abilitare le azioni nelle singole pagine delle azioni.',
      activeActions: 'Azioni attive',
      runCombinedSimulation: 'Esegui simulazione edificio',
      noUnitsSelected: 'Nessuna unità selezionata',
      noZonesSelected: 'Nessuna zona termica selezionata',
      noModulesSelected: 'Nessun modulo selezionato',
      totalInvestment: 'Investimento totale',
      priorityUpdateFailed: 'Aggiornamento priorità non riuscito',
    },
  },

  scenarioSync: {
    outOfSync:
      "L'ispezione è cambiata dall'ultima sincronizzazione di questo scenario.",
    legacyOutOfSync:
      "L'ispezione è cambiata dalla creazione di questo scenario. Questo scenario è precedente al supporto della sincronizzazione, quindi crea un nuovo scenario per includere le ultime modifiche.",
    reviewChanges: 'Rivedi le modifiche',
    notSet: 'Non impostato',
    items: 'elementi',
    dialogTitle: "Aggiorna lo scenario dall'ispezione",
    dialogIntro:
      "Le modifiche dell'ispezione vengono applicate automaticamente e le tue modifiche allo scenario vengono mantenute. Quando entrambe le parti hanno modificato lo stesso campo, scegli quale valore mantenere.",
    conflictsHeading: 'conflitti richiedono la tua decisione',
    noConflicts: '0 conflitti',
    added: 'Nuovo',
    removed: 'Rimosso',
    removedInScenario:
      'Eliminato in questo scenario, la cancellazione viene mantenuta',
    removeConflict:
      "Eliminato nell'ispezione, ma modificato in questo scenario",
    keepEntity: 'Mantieni',
    removeEntity: 'Elimina',
    keepScenario: 'Mantieni il valore dello scenario',
    takeParent: "Usa il valore dell'ispezione",
    keptOverrides:
      'campi mantengono le tue modifiche allo scenario (non vengono sovrascritti)',
    noChanges: 'Nessuna differenza da sincronizzare.',
    markSynced: 'Segna come sincronizzato',
    applySync: 'Aggiorna lo scenario',
    syncSuccess: "Scenario aggiornato dall'ispezione",
    syncError: 'Sincronizzazione dello scenario non riuscita',
    resimulateHint:
      'Esegui di nuovo la simulazione per aggiornare i risultati.',
    collections: {
      inspection: 'Ispezione',
      thermalZones: 'Zone',
      exteriorWalls: 'Pareti esterne',
      windowAreas: 'Finestre',
      doorAreas: 'Porte',
      gateAreas: 'Portoni',
      operationalLoads: 'Carichi interni',
      thermalZoneLinks: 'Collegamenti tra zone',
      hvacUnits: 'Impianti di ventilazione',
      heatingCoolingModules: 'Riscaldamento e raffreddamento',
      centralEnergyModules: 'Energia centrale',
      combustionBoilers: 'Caldaie a combustione',
      districtHeatings: 'Teleriscaldamento',
      electricBoilers: 'Caldaie elettriche',
      otherSources: 'Altre fonti di energia',
      solarTermals: 'Solare termico',
      heatPumps: 'Pompe di calore',
      productionEquipments: 'Impianti di produzione',
      solarPvModules: 'Fotovoltaico',
      excessEnergyModules: 'Energia in eccesso',
      domesticHotWaters: 'Acqua calda sanitaria',
      actionModules: 'Misure',
      pipeLinks: 'Collegamenti delle tubazioni',
      batteries: 'Batterie',
    },
  },

  scenario: {
    intro:
      "Crea una o più copie modificabili di questa ispezione. Modifica ciò che vuoi in una copia, quindi esegui la simulazione per confrontarla con l'originale.",
    introExisting:
      "Esiste già una copia scenario di questa ispezione. Aprila per continuare a modificarla o ricomincia dallo stato attuale dell'originale.",
    bannerNotice:
      "Scenario. Le modifiche qui non influenzano l'ispezione originale.",
    createScenario: 'Crea scenario',
    addScenario: 'Aggiungi scenario',
    scenarioName: 'Nome dello scenario',
    scenarioNamePlaceholder: 'es. Nuovo impianto di ventilazione',
    unnamedScenario: 'Scenario senza nome',
    creating: 'Creazione…',
    createNewScenario: 'Crea nuovo scenario',
    renameScenario: 'Modifica nome e priorità dell’azione',
    deleteScenario: 'Elimina scenario',
    confirmDeleteScenario: 'Rimuovere questo scenario?',
    working: 'Elaborazione…',
    backToOriginal: "Torna all'originale",
    confirmReplace:
      "Sostituire lo scenario esistente con una nuova copia dell'originale? Lo scenario attuale verrà eliminato.",
    createFailed: 'Impossibile creare lo scenario',
    replaceFailed: 'Impossibile sostituire lo scenario',
    renameFailed: 'Impossibile rinominare lo scenario',
    deleteFailed: 'Impossibile eliminare lo scenario',
    existingCreated: 'Creato il {date}',
    existingCreatedBy: 'Creato il {date} da {name}',
    generalNotes: 'Note generali',
    generalNotesPlaceholder:
      'Descrivi l’azione nel modo più dettagliato possibile: cosa è cambiato concretamente e perché.',
    notesRequired: 'Le note generali sono obbligatorie',
    investmentCost: 'Costo di investimento [NOK]',
    runToCompare: 'Esegui la simulazione dello scenario per confrontare',
    savingsUnavailable:
      'Non è stato ancora possibile calcolare i risparmi. I dati sui prezzi mancano o sono incompleti.',
    compareLeftLabel: 'Originale',
    compareRightLabel: 'Scenario',
    compareAgainst: 'Confronta con',
    noComparison: 'Nessun confronto',
    actionTypeLabel: 'Tipo di azione',
    selectActionType: 'Seleziona il tipo di azione',
    actionTypes: {
      buildingShell: 'Involucro edilizio',
    },
  },

  report: {
    dragDropHint: 'Riordina capitoli e campi nel menu laterale.',
    generateReport: 'Genera rapporto',
    reportLanguage: 'Lingua del rapporto',
    addChapter: 'Aggiungi capitolo',
    exportToWord: 'Esporta in Word',
    exportingToWord: 'Esportazione in Word...',
    exportingProgress: 'Esportazione in Word — {current} di {total}: {label}',
    sources: 'Fonti',
    noChapters: 'Nessun capitolo ancora. Aggiungi un capitolo per iniziare.',
    editTitle: 'Modifica titolo',
    removeChapter: 'Rimuovi capitolo',
    noFields: 'Nessun campo di testo ancora. Aggiungi un campo per iniziare.',
    fieldTitlePlaceholder: 'Titolo del nuovo campo...',
    addField: 'Aggiungi campo',
    confirmRemoveChapter: 'Rimuovere il capitolo "{title}"?',
    generateWithAI: 'Genera con IA',
    hideAuditLog: 'Nascondi registro di audit',
    showAuditLog: 'Mostra registro di audit',
    removeField: 'Rimuovi campo',
    promptLabel: 'Prompt (utilizzato per la generazione IA)',
    promptPlaceholder: 'Scrivi le istruzioni per la generazione IA...',
    generateText: 'Genera testo',
    textPlaceholder: 'Scrivi il contenuto qui, o usa la generazione IA',
    confirmRemoveField: 'Rimuovere il campo "{title}"?',
    addChapterTitle: 'Aggiungi nuovo capitolo',
    chapterTitleLabel: 'Titolo del capitolo',
    chapterTitlePlaceholder: 'Es. Clima interno e comfort',
    fetchError: 'Impossibile recuperare il rapporto',
    saveError: 'Impossibile salvare il rapporto',
    generateError: 'Impossibile generare il testo',
    generatingStatus:
      "Il report viene generato dall'IA. Potrebbe richiedere diversi minuti — la pagina si aggiornerà automaticamente quando sarà pronto.",
    generateSuccess: 'Report generato con successo',
    generateTimeout:
      'Timeout nella generazione del report. Il servizio potrebbe essere ancora in elaborazione — prova ad aggiornare la pagina più tardi.',
    noContent:
      "Nessun contenuto ancora. Genera il report o aggiungi testo per vedere un'anteprima.",
    generationPromptLog: 'Generato con prompt:',
  },
};

export default BUILDING_INSPECTION;
